<template>
  <div
    class="new-report"
    :class="{
      'new-report--planned': report.planned,
      'new-report--flash': flash,
    }"
  >
    <div class="report-header">
      <!-- Added back button -->
      <div class="heads">
        <span
          class="btn new-content-data-item-toggle-circle"
          @click="cancelReport()"
        >
          <span class="mck">e</span>
        </span>
        <h2
          v-if="this.$route.name === 'newReport'"
          class="title no-user-select"
        >
          <span
            @click="toggleAllVisible()"
            title="Изберете дали Отчета да се вижда или не в от външните потребители"
            class="mck icon-notVisible no-user-select"
            :class="{ 'icon-isVisible': report.allVisible }"
            >{{ report.allVisible ? "r" : "q" }}</span
          >
          <template v-if="report.planned">Ново планиране</template>
          <template v-else> Нов отчет </template>
        </h2>
        <h2
          v-if="this.$route.name === 'editReport'"
          class="title no-user-select"
        >
          <span
            @click="toggleAllVisible()"
            title="Изберете дали Отчета да се вижда или не в от външните потребители"
            class="mck icon-notVisible no-user-select"
            :class="{ 'icon-isVisible': report.allVisible }"
            >{{ report.allVisible ? "r" : "q" }}</span
          >
          <template v-if="report.planned">Редактиране на планиране</template>
          <template v-else-if="this.report.isSelfReport"
            >Преглед на самоотчет</template
          >
          <template v-else>Редактиране на отчет</template>
          <span v-if="report.isInvalid">
            (
            <img class="flag" src="../assets/img/flag_yes.svg" alt="Valid" />
            Грешен отчет)
          </span>
        </h2>
      </div>
      <!-- NEW REPORT BUTTONS DESKTOP-->
      <div class="btns desktop" v-if="allowSave">
        <button class="btn btn-close" @click="cancelReport()">
          <span class="mck">F</span>
          Отказ
        </button>
        <button class="btn btn-new" @click="save()">
          <span class="mck">Y</span>
          Запис
        </button>
      </div>
    </div>

    <!-- NEW REPORT CONTENT -->
    <div
      class="new-wrapper new-wrapper--controlls"
      :class="{ 'new-wrapper-invalid': report.isInvalid }"
    >
      <!-- ROW 1 DESKTOP -->
      <div class="new-content-inputs">
        <!-- ДАТА -->
        <div class="new-input-wrapper">
          <div class="new-input">
            <span class="mck icon--date">D</span>
            <input
              class="date"
              type="text"
              id="newReportDate"
              @click="openDropdown(0)"
              @focus="openDropdown(0)"
              @blur="closeDropdown(0)"
              placeholder="Дата"
              v-model="formatedDate"
              :disabled="this.$route.name === 'editReport'"
              readonly
            />
            <span v-if="this.$route.name === 'editReport'" class="disabled"
              >A</span
            >
          </div>
          <div
            class="new-input-dropdown datepicker-dropdown"
            :class="{ 'datepicker-dropdown-active': openedDropdown[0] }"
          >
            <datepicker
              :language="bg"
              :inline="true"
              :monday-first="true"
              :wrapper-class="'custom-datepicker'"
              :calendar-class="'custom-calendar'"
              v-model="report.date"
              @selected="closeDropdown(0), reportChanged(), getInventories()"
            ></datepicker>
          </div>
        </div>
        <!-- DESKTOP COMPANY -->
        <div class="new-input-wrapper desktop">
          <div
            class="new-input"
            :class="{ 'new-input-disabled': this.$route.name === 'editReport' }"
          >
            <span class="mck icon--company">a</span>
            <!-- NOT SELECTED -->
            <input
              v-if="!report.company._id.length"
              type="text"
              placeholder="Име на отдел"
              @focus="getCompanies(), openDropdown(3)"
              @blur="closeDropdown(3)"
              v-model="searchCompanies"
              :disabled="this.$route.name === 'editReport'"
            />
            <!-- SELECTED -->
            <input
              v-else
              type="text"
              placeholder="Име на отдел"
              @focus="getCompanies(), openDropdown(3)"
              v-model="report.company.companyName"
              @blur="closeDropdown(3)"
              :disabled="
                this.$route.name === 'editReport' || report.company._id.length
              "
            />
            <span
              v-if="
                report.company._id.length && this.$route.name !== 'editReport'
              "
              class="clear"
              @click="resetSelectedCompany()"
              >F</span
            >
            <span v-if="this.$route.name === 'editReport'" class="disabled"
              >A</span
            >
          </div>
          <!-- DROP-DOWN COMPANIES -->
          <div
            class="new-input-dropdown new-input-dropdown--big"
            :class="{ 'new-input-dropdown-active': openedDropdown[3] }"
          >
            <ul v-if="companies.length">
              <li
                v-for="c in filteredCompanies()"
                :key="c._id"
                @click="selectCompany(c), getProjects(true), reportChanged()"
              >
                {{ c.companyName }}
              </li>
            </ul>
          </div>
        </div>
        <!-- MOBILE COMPANY -->
        <label class="label mobile" for="company">Отдел</label>
        <div class="new-input mobile">
          <span class="mck icon--company">a</span>
          <!-- NOT SELECTED -->
          <select
            v-if="$route.name !== 'editReport'"
            id="company"
            class="select"
            v-model="company"
            @change="selectCompany(company), getProjects(true), reportChanged()"
          >
            <!-- @click.native="selectCompany(c), getProjects(), reportChanged()"    -->
            <option value disabled hidden v-if="$route.name !== 'editReport'">
              Име на отдел
            </option>
            <option
              value="Последни отдели:"
              v-if="$route.name !== 'editReport'"
              disabled
            >
              Последни отдели:
            </option>
            <template v-for="c in latestCompanies">
              <option
                :value="c"
                v-if="$route.name !== 'editReport'"
                :key="`latestCompanies-${c._id}`"
                selected
              >
                {{ c.companyName }}
              </option>
            </template>
            <option value v-if="$route.name !== 'editReport'" disabled>
              Всички отдели:
            </option>
            <template v-for="(c, index) in companies">
              <option
                v-if="companies.length && $route.name !== 'editReport'"
                :value="c"
                :key="index"
                selected
              >
                {{ c.companyName }}
              </option>
            </template>
            <option
              :value="report.company"
              v-if="this.$route.name === 'editReport'"
              selected
              disabled
            >
              {{ report.company.companyName }}
            </option>
          </select>
          <!-- SELECTED -->
          <input
            v-else
            type="text"
            placeholder="Име на отдел"
            v-model="report.company.companyName"
            :disabled="
              this.$route.name === 'editReport' || report.company._id.length
            "
          />
          <span v-if="this.$route.name === 'editReport'" class="disabled"
            >A</span
          >
        </div>
        <!-- PROJECT -->
        <div class="new-input-wrapper desktop">
          <div
            class="new-input"
            :class="{ 'new-input-disabled': this.$route.name === 'editReport' }"
          >
            <span class="mck icon--project">h</span>
            <!-- NOT SELECTED -->
            <input
              v-if="!report.project._id.length"
              type="text"
              placeholder="Име на проект"
              @focus="getProjects(false), openDropdown(4)"
              @blur="closeDropdown(4)"
              v-model="searchProjects"
              :disabled="this.$route.name === 'editReport'"
            />
            <!-- SELECTED -->
            <input
              v-else
              type="text"
              placeholder="Име на проект"
              @focus="getProjects(false), openDropdown(4)"
              @blur="closeDropdown(4)"
              v-model="report.project.projectName"
              :disabled="
                this.$route.name === 'editReport' || report.project._id.length
              "
            />
            <span
              v-if="
                report.project._id.length && this.$route.name !== 'editReport'
              "
              class="clear"
              @click="resetSelectedProject()"
              >F</span
            >
            <span v-if="this.$route.name === 'editReport'" class="disabled"
              >A</span
            >
          </div>
          <!-- DROP-DOWN PROJECTS -->
          <div
            class="new-input-dropdown new-input-dropdown--big"
            :class="{ 'new-input-dropdown-active': openedDropdown[4] }"
          >
            <ul v-if="projects.length">
              <li
                v-for="p in filteredProjects()"
                :key="p._id"
                @click="selectProject(p)"
              >
                {{ p.projectName }}
              </li>
            </ul>
          </div>
        </div>
        <!-- MOBILE PROJECT -->
        <label class="label mobile" for="project">Проект</label>
        <div class="new-input mobile">
          <span class="mck icon--project">h</span>
          <!-- NOT SELECTED -->
          <select
            v-if="this.$route.name !== 'editReport'"
            id="project"
            class="select"
            v-model="project"
            @change="selectProject(project)"
          >
            <option value disabled hidden>Име на проект</option>
            <template v-for="(p, index) in projects">
              <option :key="index" :value="p">{{ p.projectName }}</option>
            </template>
            <!-- <option
                :value="report.project"
                selected
            >{{report.project.projectName}}</option>-->
          </select>
          <!-- SELECTED -->
          <input
            v-else
            type="text"
            placeholder="Име на проект"
            v-model="report.project.projectName"
            :disabled="
              this.$route.name === 'editReport' || report.project._id.length
            "
          />
          <span v-if="this.$route.name === 'editReport'" class="disabled"
            >A</span
          >
        </div>
      </div>
      <!-- WORKERS / MATERIALS / ACTIVITIES / MECHANIZATIONS FIRST ROW SHOWN WHEN VIEW LISTS IS ACTIVE -->
      <div class="new-content-data-row" v-if="!report.isSelfReport">
        <!-- ACTIVITIES -->
        <div
          class="new-content-data-item"
          :class="{
            'new-content-data-item--transparent':
              selectedProject === undefined &&
              this.$route.name !== 'editReport',
          }"
        >
          <div
            class="new-content-data-item-toggle"
            @click="openAddActivitiesModal()"
          >
            <span class="mck">U</span>
            <p>ДЕЙНОСТИ</p>
          </div>
        </div>
        <!-- WORKERS -->
        <div
          class="new-content-data-item"
          :class="{
            'new-content-data-item--transparent':
              selectedProject === undefined &&
              this.$route.name !== 'editReport',
          }"
        >
          <div
            class="new-content-data-item-toggle"
            @click="openAddUsersModal()"
          >
            <span class="mck">V</span>
            <p>ИЗПЪЛНИТЕЛИ</p>
          </div>
        </div>
        <!-- MECHANIZATIONS -->
        <div
          class="new-content-data-item"
          :class="{
            'new-content-data-item--transparent':
              selectedProject === undefined &&
              this.$route.name !== 'editReport',
          }"
        >
          <div
            class="new-content-data-item-toggle"
            @click="openAddMechanizationsModal()"
          >
            <span class="mck">n</span>
            <p>СОБСТВЕНА<br />МЕХАНИЗАЦИЯ</p>
          </div>
        </div>
        <div
          class="new-content-data-item"
          :class="{
            'new-content-data-item--transparent':
              selectedProject === undefined &&
              this.$route.name !== 'editReport',
          }"
        >
          <div
            class="new-content-data-item-toggle"
            @click="openAddRentedMechanizationsModal()"
          >
            <span class="mck">m</span>
            <p>НАЕТА<br />МЕХАНИЗАЦИЯ</p>
          </div>
        </div>
        <!-- MATERIALS -->
        <div
          class="new-content-data-item"
          :class="{
            'new-content-data-item--transparent':
              selectedProject === undefined &&
              this.$route.name !== 'editReport',
          }"
        >
          <div
            class="new-content-data-item-toggle"
            @click="openAddMaterialsModal()"
          >
            <span class="mck">T</span>
            <p>МАТЕРИАЛИ</p>
          </div>
        </div>
      </div>
    </div>
    <div
      class="new-wrapper new-wrapper--content"
      :class="{ 'new-wrapper-invalid': report.isInvalid }"
      v-if="viewLists()"
    >
      <div class="new-content">
        <!-- WORKERS / MATERIALS / ACTIVITIES / MECHANIZATIONS -->
        <div
          class="new-content-data-row"
          :class="{ 'new-content-data-row-active': viewLists() }"
        >
          <!-- WORKERS -->
          <div
            class="new-content-data-item expense"
            v-if="canSeeContent('worker_section')"
          >
            <div v-if="viewLists()" class="new-content-data-item-content">
              <table>
                <thead
                  class="new-content-data-item-toggle"
                  @click="!report.isSelfReport && openAddUsersModal()"
                >
                  <tr title="Редакция на работници">
                    <td>Работници</td>
                    <td v-if="report.initAsPlanned && !report.planned">
                      <span class="desktop">Планирани часове</span>
                    </td>
                    <td>
                      <span class="desktop">
                        <template v-if="report.planned"
                          >Планирано работно време, ч.</template
                        >
                        <template v-else>Отчетени часове</template>
                      </span>
                    </td>
                    <td class="no-min">
                      <span class="desktop">Ставка</span>
                    </td>
                    <td v-if="accessCache['prices']">
                      <span class="desktop">Себестойност на труда</span>
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!report.workers.length">
                    <td></td>
                  </tr>
                  <template v-for="(worker, i) in report.workers">
                    <tr
                      :key="`userPart-${i}`"
                      v-if="
                        (report.workers[i - 1]
                          ? report.workers[i - 1].part !== worker.part
                          : true) && (!report.isSelfReport ? worker.part : true)
                      "
                      class="part-tr"
                    >
                      <td>
                        <div class="part-name-wrapper">
                          <span class="part-name-span"
                            >ЧАСТ
                            <template v-if="!report.isSelfReport">
                              {{ worker.part }}
                            </template>
                          </span>
                          <TheInput
                            v-if="report.isSelfReport"
                            type="dropdown"
                            :options="getParts()"
                            placeholder="Избери част"
                            v-model="worker.part"
                            :disabled="isInputDisabled('accept_self_reports')"
                            @update:modelValue="$set(worker, 'part', $event)"
                          />
                        </div>
                      </td>
                      <td></td>
                      <td></td>
                      <td v-if="report.initAsPlanned && !report.planned"></td>
                      <td v-if="accessCache['prices']">
                        <p>{{ getTotalWorkers(worker.part).toFixed(2) }} €</p>
                      </td>
                    </tr>
                    <tr :key="`addedWorker-${i}-${worker._id}`">
                      <td class="ma-cell no-user-select">
                        <!-- ma-cell-name -->
                        <span
                          v-if="!isInputDisabled('worker_section')"
                          title="Премахни от отчета"
                          @click="deleteItem('workers', i)"
                          class="mck icon--delete"
                        >
                          b
                        </span>
                        <span
                          title="Изберете дали служителя да се вижда или не в Отчета към външните потребители"
                          @click="changeVisibleState(worker, 'worker_section')"
                          class="mck icon-notVisible"
                          :class="{ 'icon-isVisible': worker.isVisible }"
                          >{{ worker.isVisible ? "r" : "q" }}</span
                        >
                        <div class="name-buttons-wrapper">
                          <p>
                            {{ worker.name }}
                          </p>

                          <section
                            class="tasks-buttons"
                            v-if="!isInputDisabled('worker_section')"
                          >
                            <div
                              v-if="worker.tasks.length && !report.isSelfReport"
                              class="add-remove"
                            >
                              <span class="mck" @click="removeTask(worker)"
                                >s</span
                              >
                              <span class="number">{{
                                worker.tasks.length
                              }}</span>
                              <span class="mck" @click="addTask(worker)"
                                >t</span
                              >
                            </div>

                            <span
                              title="Добави подзадачи и дейности"
                              class="mck toggle-tasks"
                              v-if="!worker.tasks.length"
                              @click="addTask(worker)"
                              >v</span
                            >
                          </section>
                        </div>
                        <SelectHour
                          v-model="worker.startHour"
                          :end="worker.endHour"
                          :disabled="
                            isInputDisabled(
                              report.isSelfReport
                                ? 'accept_self_reports'
                                : 'worker_section'
                            )
                          "
                          :filters="getSameItemFilters('workers', i)"
                          @change="changeField('workers', i)"
                        />
                        <SelectHour
                          v-model="worker.endHour"
                          :disabled="
                            isInputDisabled(
                              report.isSelfReport
                                ? 'accept_self_reports'
                                : 'worker_section'
                            )
                          "
                          :start="worker.startHour"
                          :filters="getSameItemFilters('workers', i)"
                          :skipFirst="true"
                          @change="changeField('workers', i)"
                        />
                      </td>
                      <div v-if="worker.tasks.length" class="tasks">
                        <p>
                          {{
                            report.isSelfReport
                              ? "КОМЕНТАР"
                              : "ПОДЗАДАЧИ И ДЕЙНОСТИ"
                          }}
                        </p>
                        <div
                          v-for="(t, j) of worker.tasks"
                          :key="`${t}-${j}`"
                          class="tasks-input-wrapper"
                        >
                          <span class="number">{{ j + 1 }}</span>
                          <input
                            :disabled="
                              isInputDisabled(
                                report.isSelfReport
                                  ? 'accept_self_reports'
                                  : 'worker_section'
                              )
                            "
                            v-model="t.name"
                            placeholder="Описание на задачата"
                            type="text"
                          />

                          <section class="tasks-hours-selection">
                            <SelectHour
                              v-model="t.startHour"
                              :start="worker.startHour"
                              :disabled="
                                isInputDisabled(
                                  report.isSelfReport
                                    ? 'accept_self_reports'
                                    : 'worker_section'
                                )
                              "
                              :end="t.endHour"
                              :filters="[
                                {
                                  to: j
                                    ? worker.tasks[j - 1].endHour
                                    : worker.startHour,
                                },
                                {
                                  from: worker.endHour,
                                },
                              ]"
                              @change="changeField('workers', i)"
                              taskHours="true"
                              :taskHoursFirst="!j"
                            />
                            <SelectHour
                              v-model="t.endHour"
                              :disabled="
                                !t.startHour ||
                                isInputDisabled('accept_self_reports')
                              "
                              :start="t.startHour"
                              :filters="[
                                { to: worker.startHour },
                                {
                                  from: worker.tasks[j + 1]
                                    ? worker.tasks[j + 1].startHour
                                    : worker.endHour,
                                },
                              ]"
                              :skipFirst="true"
                              @change="changeField('workers', i)"
                              taskHours="true"
                            />
                          </section>
                        </div>
                      </div>
                      <td v-if="report.initAsPlanned && !report.planned">
                        <WorktimeTag
                          :date="report.date"
                          :start="worker.plannedStartHour"
                          :end="worker.plannedEndHour"
                          :planned="true"
                        />
                      </td>
                      <td>
                        <div class="input-and-percent-wrapper">
                          <template
                            v-if="
                              report.initAsPlanned &&
                              !report.planned &&
                              worker.plannedStartHour &&
                              worker.plannedEndHour
                            "
                          >
                            <span
                              class="mck2 worker-hours-toggle"
                              title="Изберете, ако планираният работник не участва в реалния отчет"
                              v-if="worker.startHour && worker.endHour"
                              @click="
                                resetWorkerHours(worker),
                                  changeField('workers', i)
                              "
                              >7</span
                            >
                            <span
                              class="mck2 worker-hours-toggle"
                              title="Изберете, за да добавите отново планираният работник"
                              v-else
                              @click="
                                restoreWorkerHours(worker),
                                  changeField('workers', i)
                              "
                              >9</span
                            >
                          </template>
                          <span class="mck2 worker-hours-toggle hidden" v-else
                            >9</span
                          >

                          <WorktimeTag
                            :date="report.date"
                            :start="worker.startHour"
                            :end="worker.endHour"
                          />
                          <PercentTag
                            v-if="report.initAsPlanned && !report.planned"
                            :planned="
                              calculateHours(
                                report.date,
                                worker.plannedStartHour,
                                worker.plannedEndHour
                              ).total
                            "
                            :real="
                              calculateHours(
                                report.date,
                                worker.startHour,
                                worker.endHour
                              ).total
                            "
                          />
                        </div>
                      </td>
                      <td class="no-min no-wrap">
                        <template v-if="worker.position"
                          >{{ worker.position.rate }} € &nbsp;&nbsp;&nbsp;({{
                            worker.position.name
                          }})</template
                        >
                        <template v-else>0 €</template>
                      </td>
                      <td v-if="accessCache['prices']" class="no-wrap">
                        {{
                          getWorkerCost(
                            worker,
                            calculateHours(
                              report.date,
                              worker.startHour,
                              worker.endHour
                            )
                          )
                        }}
                        €
                      </td>
                    </tr>
                  </template>
                  <tr class="tr-totals" v-if="accessCache['prices']">
                    <td
                      :colspan="report.initAsPlanned && !report.planned ? 4 : 3"
                    >
                      <p>Разходи за труд:</p>
                    </td>
                    <td>
                      <p class="tr-totals__expense">
                        {{ getTotalWorkers().toFixed(2) }} €
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          <template v-if="report.isSelfReport && !report.checkedBy">
            <div
              class="decision-wrapper"
              v-if="accessCache['accept_self_reports']"
            >
              <div class="custom-btn" @click="setSelfReportStatus(true)">
                <span class="mck3">I</span>
                <p>ПРИЕМИ ТОЗИ ОТЧЕТ</p>
              </div>

              <div
                class="custom-btn custom-btn--decline"
                @click="setSelfReportStatus(false)"
              >
                <span class="mck3">K</span>
                <p>ОТКАЖИ ТОЗИ ОТЧЕТ</p>
              </div>
            </div>
          </template>

          <!-- MECHANIZATIONS AND EQUIPMENTS -->
          <div
            class="new-content-data-item expense"
            v-if="canSeeContent('tools_section')"
          >
            <div v-if="viewLists()" class="new-content-data-item-content">
              <table>
                <thead
                  class="new-content-data-item-toggle"
                  @click="openAddMechanizationsModal()"
                >
                  <tr title="Редакция на собствени механизации">
                    <td>
                      <!-- Собствени механизации -->
                      Строителната техника
                      <router-link
                        v-if="!isInputDisabled('tools_section')"
                        class="link"
                        :to="`/companies/${report.company._id}/${report.project._id}?openModal=mechanizations`"
                        target="_blank"
                        @click.native="$event.stopImmediatePropagation()"
                        >Редакция в проекта</router-link
                      >
                    </td>
                    <td
                      class="padding-right"
                      v-if="report.initAsPlanned && !report.planned"
                    >
                      <span class="desktop">Планирана</span>
                    </td>
                    <td>
                      <span class="desktop">
                        <template v-if="report.planned">Планирана</template>
                        <template v-else>Отчетена</template>
                      </span>
                    </td>
                    <template v-if="accessCache['prices']">
                      <td>
                        <span class="desktop">Ед. Цена</span>
                      </td>
                      <td>
                        <span class="desktop">Сума</span>
                      </td>
                    </template>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!report.mechanizations.length">
                    <td></td>
                  </tr>
                  <template v-for="(m, index) in report.mechanizations">
                    <tr
                      :key="`addedReportPart-${index}`"
                      class="part-tr"
                      v-if="m.part"
                    >
                      <!-- v-if="
                        (report.mechanizations[index - 1]
                          ? report.mechanizations[index - 1].part !== m.part
                          : true) && m.part
                      " -->
                      <td>
                        <div class="part-name-wrapper">
                          <span class="part-name-span">ЧАСТ</span>
                          <TheInput
                            type="dropdown"
                            :options="getParts()"
                            placeholder="Избери част"
                            :disabled="isInputDisabled('tools_section')"
                            v-model="m.part"
                            @update:modelValue="$set(m, 'part', $event)"
                          />
                        </div>
                      </td>
                      <template v-if="accessCache['prices']">
                        <td></td>
                        <td></td>
                      </template>
                      <td v-if="report.initAsPlanned && !report.planned"></td>
                      <td v-if="accessCache['prices']">
                        <p>
                          {{ getTotals("mechanizations", m.part).toFixed(2) }}
                          €
                        </p>
                      </td>
                    </tr>
                    <tr :key="`addedReportMechanization-${index}-${m.name}`">
                      <!-- ma-cell-name -->
                      <td
                        class="ma-cell no-user-select"
                        :class="{ 'ma-cell-additional': m.isAdditional }"
                      >
                        <!-- <span class="mck" v-if="m.isAdditional">O</span> -->
                        <span
                          v-if="!isInputDisabled('tools_section')"
                          title="Премахни от отчета"
                          @click="deleteItem('mechanizations', index)"
                          class="mck icon--delete"
                        >
                          b
                        </span>
                        <span
                          title="Изберете дали механизацията да се вижда или не в Отчета към външните потребители"
                          @click="changeVisibleState(m, 'tools_section')"
                          class="mck icon-notVisible"
                          :class="{ 'icon-isVisible': m.isVisible }"
                          >{{ m.isVisible ? "r" : "q" }}</span
                        >
                        <div class="name-buttons-wrapper">
                          <p>
                            {{ getItemName(m) }}
                          </p>

                          <section
                            class="tasks-buttons"
                            v-if="!isInputDisabled('tools_section')"
                          >
                            <div
                              v-if="m.tasks && m.tasks.length"
                              class="add-remove"
                            >
                              <span class="mck" @click="removeTask(m)">s</span>
                              <span class="number">{{ m.tasks.length }}</span>
                              <span class="mck" @click="addTask(m)">t</span>
                            </div>

                            <span
                              title="Добави подзадачи и дейности"
                              class="mck toggle-tasks"
                              v-if="m.tasks && !m.tasks.length"
                              @click="addTask(m)"
                              >v</span
                            >
                          </section>
                        </div>
                        <SelectHour
                          v-model="m.startHour"
                          :disabled="isInputDisabled('tools_section')"
                          :end="m.endHour"
                          :filters="getSameItemFilters('mechanizations', index)"
                          @change="
                            changeField('mechanizations', index),
                              setInvItems('mechanizations', index)
                          "
                        />
                        <SelectHour
                          v-model="m.endHour"
                          :start="m.startHour"
                          :disabled="isInputDisabled('tools_section')"
                          :filters="getSameItemFilters('mechanizations', index)"
                          :skipFirst="true"
                          @change="
                            changeField('mechanizations', index),
                              setInvItems('mechanizations', index)
                          "
                        />
                      </td>
                      <div v-if="m.tasks && m.tasks.length" class="tasks">
                        <p>ПОДЗАДАЧИ И ДЕЙНОСТИ</p>

                        <div
                          v-for="(t, i) of m.tasks"
                          :key="`${t}-${i}`"
                          class="tasks-input-wrapper"
                        >
                          <span class="number">{{ i + 1 }}</span>
                          <input
                            v-model="t.name"
                            :disabled="isInputDisabled('tools_section')"
                            placeholder="Описание на задачата"
                            type="text"
                          />
                          <section class="tasks-hours-selection">
                            <SelectHour
                              v-model="t.startHour"
                              :disabled="isInputDisabled('tools_section')"
                              :start="m.startHour"
                              :end="t.endHour"
                              :filters="[
                                {
                                  to: i ? m.tasks[i - 1].endHour : m.startHour,
                                },
                                {
                                  from: m.endHour,
                                },
                              ]"
                              @change="changeField('mechanizations', index)"
                              :taskHoursFirst="!i"
                              taskHours="true"
                            />
                            <SelectHour
                              v-model="t.endHour"
                              :disabled="
                                !t.startHour || isInputDisabled('tools_section')
                              "
                              :start="t.startHour"
                              :filters="[
                                { to: m.startHour },
                                {
                                  from: m.tasks[i + 1]
                                    ? m.tasks[i + 1].startHour
                                    : m.endHour,
                                },
                              ]"
                              :skipFirst="true"
                              @change="changeField('mechanizations', index)"
                              taskHours="true"
                            />
                          </section>
                        </div>
                      </div>
                      <td
                        class="ma-cell ma-cell-nowrap padding-right"
                        v-if="report.initAsPlanned && !report.planned"
                      >
                        {{ m.plannedItems || 0 }} {{ m.unit }}
                      </td>
                      <td class="ma-cell ma-cell-nowrap">
                        <div class="input-and-percent-wrapper">
                          <div>
                            <input
                              class="ma-cell-input"
                              :value="m.items"
                              :disabled="true"
                            />
                            ч.
                          </div>
                          <PercentTag
                            v-if="report.initAsPlanned && !report.planned"
                            :planned="m.plannedItems"
                            :real="m.items"
                          />
                        </div>
                      </td>
                      <template v-if="accessCache['prices']">
                        <td class="ma-cell ma-cell-nowrap">
                          <input
                            class="ma-cell-input"
                            v-model="m.price"
                            @keyup="changeField('mechanizations', index)"
                            type="number"
                            :disabled="isInputDisabled('prices')"
                            min="0"
                          />
                          €
                        </td>
                        <td class="ma-cell ma-cell-nowrap">
                          {{ (+m.items * +m.price).toFixed(2) }} €
                        </td>
                      </template>
                    </tr>
                  </template>
                  <tr class="tr-totals" v-if="accessCache['prices']">
                    <td
                      :colspan="report.initAsPlanned && !report.planned ? 4 : 3"
                    >
                      <p>Разход за собствена механизация:</p>
                    </td>
                    <td>
                      <p class="tr-totals__expense">
                        {{ getTotals("mechanizations").toFixed(2) }} €
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- INVENTORY -->
          <div
            class="new-content-data-item expense"
            v-if="canSeeContent('inventory_section')"
          >
            <div v-if="viewLists()" class="new-content-data-item-content">
              <table>
                <thead class="new-content-data-item-toggle">
                  <tr title="Редакция на собствени механизации">
                    <td>Инструменти</td>
                    <td
                      class="padding-right"
                      v-if="report.initAsPlanned && !report.planned"
                    >
                      <span class="desktop">Планирана</span>
                    </td>
                    <td>
                      <span class="desktop">
                        <template v-if="report.planned">Планирана</template>
                        <template v-else>Отчетена</template>
                      </span>
                    </td>
                    <template v-if="accessCache['prices']">
                      <td>
                        <span class="desktop">Ед. Цена</span>
                      </td>
                      <td>
                        <span class="desktop">Сума</span>
                      </td>
                    </template>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!report.tools.length">
                    <td></td>
                  </tr>
                  <template v-for="(m, index) in report.tools">
                    <tr
                      :key="`addedReportPart-${index}`"
                      v-if="m.part"
                      class="part-tr"
                    >
                      <!-- v-if="
                        (report.tools[index - 1]
                          ? report.tools[index - 1].part !== m.part
                          : true) && m.part
                      " -->
                      <td>
                        <div class="part-name-wrapper">
                          <span class="part-name-span">ЧАСТ</span>
                          <TheInput
                            type="dropdown"
                            :options="getParts()"
                            placeholder="Избери част"
                            :disabled="isInputDisabled('inventory_section')"
                            v-model="m.part"
                            @update:modelValue="$set(m, 'part', $event)"
                          />
                        </div>
                      </td>
                      <template v-if="accessCache['prices']">
                        <td></td>
                        <td></td>
                      </template>
                      <td v-if="report.initAsPlanned && !report.planned"></td>
                      <td v-if="accessCache['prices']">
                        <p>
                          {{ getTotals("tools", m.part).toFixed(2) }}
                          €
                        </p>
                      </td>
                    </tr>
                    <tr :key="`addedReportMechanization-${index}-${m.name}`">
                      <td
                        class="ma-cell no-user-select"
                        :class="{ 'ma-cell-additional': m.isAdditional }"
                      >
                        <span
                          title="Премахни от отчета"
                          @click="deleteItem('tools', index)"
                          class="mck icon--delete"
                        >
                          b
                        </span>
                        <span
                          title="Изберете дали механизацията да се вижда или не в Отчета към външните потребители"
                          @click="changeVisibleState(m, 'inventory_section')"
                          class="mck icon-notVisible"
                          :class="{ 'icon-isVisible': m.isVisible }"
                          >{{ m.isVisible ? "r" : "q" }}</span
                        >
                        <div class="name-buttons-wrapper">
                          <p>
                            {{ getItemName(m) }}
                          </p>

                          <section
                            class="tasks-buttons"
                            v-if="!isInputDisabled('inventory_section')"
                          >
                            <div
                              v-if="m.tasks && m.tasks.length"
                              class="add-remove"
                            >
                              <span class="mck" @click="removeTask(m)">s</span>
                              <span class="number">{{ m.tasks.length }}</span>
                              <span class="mck" @click="addTask(m)">t</span>
                            </div>
                            <span
                              title="Добави подзадачи и дейности"
                              class="mck toggle-tasks"
                              v-if="m.tasks && !m.tasks.length"
                              @click="addTask(m)"
                              >v</span
                            >
                          </section>
                        </div>
                        <SelectHour
                          v-model="m.startHour"
                          :end="m.endHour"
                          :disabled="isInputDisabled('inventory_section')"
                          :filters="getSameItemFilters('tools', index)"
                          @change="
                            changeField('tools', index),
                              setInvItems('tools', index)
                          "
                        />
                        <SelectHour
                          v-model="m.endHour"
                          :start="m.startHour"
                          :disabled="isInputDisabled('inventory_section')"
                          :filters="getSameItemFilters('tools', index)"
                          :skipFirst="true"
                          @change="
                            changeField('tools', index),
                              setInvItems('tools', index)
                          "
                        />
                      </td>
                      <div v-if="m.tasks && m.tasks.length" class="tasks">
                        <p>ПОДЗАДАЧИ И ДЕЙНОСТИ</p>

                        <div
                          v-for="(t, i) of m.tasks"
                          :key="`${t}-${i}`"
                          class="tasks-input-wrapper"
                        >
                          <span class="number">{{ i + 1 }}</span>
                          <input
                            v-model="t.name"
                            :disabled="isInputDisabled('inventory_section')"
                            placeholder="Описание на задачата"
                            type="text"
                          />
                          <section class="tasks-hours-selection">
                            <SelectHour
                              v-model="t.startHour"
                              :start="m.startHour"
                              :disabled="isInputDisabled('inventory_section')"
                              :end="t.endHour"
                              :filters="[
                                {
                                  to: i ? m.tasks[i - 1].endHour : m.startHour,
                                },
                                {
                                  from: m.endHour,
                                },
                              ]"
                              @change="changeField('tools', index)"
                              :taskHoursFirst="!i"
                              taskHours="true"
                            />
                            <SelectHour
                              v-model="t.endHour"
                              :disabled="
                                !t.startHour ||
                                isInputDisabled('inventory_section')
                              "
                              :start="t.startHour"
                              :filters="[
                                { to: m.startHour },
                                {
                                  from: m.tasks[i + 1]
                                    ? m.tasks[i + 1].startHour
                                    : m.endHour,
                                },
                              ]"
                              :skipFirst="true"
                              @change="changeField('tools', index)"
                              taskHours="true"
                            />
                          </section>
                        </div>
                      </div>
                      <td
                        class="ma-cell ma-cell-nowrap padding-right"
                        v-if="report.initAsPlanned && !report.planned"
                      >
                        {{ m.plannedItems || 0 }} {{ m.unit }}
                      </td>
                      <td class="ma-cell ma-cell-nowrap">
                        <div class="input-and-percent-wrapper">
                          <div>
                            <input
                              class="ma-cell-input"
                              :value="m.items"
                              :disabled="true"
                            />
                            ч.
                          </div>
                          <PercentTag
                            v-if="report.initAsPlanned && !report.planned"
                            :planned="m.plannedItems"
                            :real="m.items"
                          />
                        </div>
                      </td>
                      <template v-if="accessCache['prices']">
                        <td class="ma-cell ma-cell-nowrap">
                          <input
                            class="ma-cell-input"
                            v-model="m.price"
                            :disabled="isInputDisabled('prices')"
                            @keyup="changeField('tools', index)"
                            type="number"
                            min="0"
                          />
                          €
                        </td>
                        <td class="ma-cell ma-cell-nowrap">
                          {{ (+m.items * +m.price).toFixed(2) }} €
                        </td>
                      </template>
                    </tr>
                  </template>
                  <tr class="tr-totals" v-if="accessCache['prices']">
                    <td
                      :colspan="report.initAsPlanned && !report.planned ? 4 : 3"
                    >
                      <p>Разход за инструменти:</p>
                    </td>
                    <td>
                      <p class="tr-totals__expense"> 
                        {{ getTotals("tools").toFixed(2) }} €
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- RENTED MECHANIZATIONS -->
          <div
            class="new-content-data-item expense"
            v-if="canSeeContent('rented_mechanization_section')"
          >
            <div v-if="viewLists()" class="new-content-data-item-content">
              <table>
                <thead
                  class="new-content-data-item-toggle"
                  @click="openAddRentedMechanizationsModal()"
                >
                  <tr title="Редакция на наети механизации">
                    <td>
                      Наети механизации
                      <router-link
                        v-if="!isInputDisabled('rented_mechanization_section')"
                        class="link"
                        :to="`/companies/${report.company._id}/${report.project._id}?openModal=rentedMechanizations`"
                        target="_blank"
                        @click.native="$event.stopImmediatePropagation()"
                        >Редакция в проекта</router-link
                      >
                    </td>
                    <td
                      class="padding-right"
                      v-if="report.initAsPlanned && !report.planned"
                    >
                      <span class="desktop">Планирана</span>
                    </td>
                    <td>
                      <span class="desktop">
                        <template v-if="report.planned">Планирана</template>
                        <template v-else>Отчетена</template>
                      </span>
                    </td>
                    <template v-if="accessCache['prices']">
                      <td>
                        <span class="desktop">Ед. Цена</span>
                      </td>
                      <td>
                        <span class="desktop">Сума</span>
                      </td>
                    </template>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!report.rentedMechanizations.length">
                    <td></td>
                  </tr>
                  <template v-for="(m, index) in report.rentedMechanizations">
                    <tr
                      :key="`addedReportPart-${index}`"
                      v-if="
                        (report.rentedMechanizations[index - 1]
                          ? report.rentedMechanizations[index - 1].part !==
                            m.part
                          : true) && m.part
                      "
                      class="part-tr"
                    >
                      <td>
                        <span class="part-name-span">ЧАСТ {{ m.part }}</span>
                      </td>
                      <template v-if="accessCache['prices']">
                        <td></td>
                        <td></td>
                      </template>
                      <td v-if="report.initAsPlanned && !report.planned"></td>
                      <td v-if="accessCache['prices']">
                        <p>
                          {{
                            getTotals("rentedMechanizations", m.part).toFixed(2)
                          }}
                          €
                        </p>
                      </td>
                    </tr>
                    <tr
                      :key="`addedReportRentedMechanization-${index}-${m.name}`"
                    >
                      <td
                        class="ma-cell no-user-select"
                        :class="{ 'ma-cell-additional': m.isAdditional }"
                      >
                        <!-- ma-cell-name -->
                        <!-- <span class="mck" v-if="m.isAdditional">O</span> -->
                        <span
                          v-if="
                            !isInputDisabled('rented_mechanization_section')
                          "
                          title="Премахни от отчета"
                          @click="deleteItem('rentedMechanizations', index)"
                          class="mck icon--delete"
                        >
                          b
                        </span>
                        <span
                          title="Изберете дали механизацията да се вижда или не в Отчета към външните потребители"
                          @click="
                            changeVisibleState(
                              m,
                              'rented_mechanization_section'
                            )
                          "
                          class="mck icon-notVisible"
                          :class="{ 'icon-isVisible': m.isVisible }"
                          >{{ m.isVisible ? "r" : "q" }}</span
                        >
                        <div class="name-buttons-wrapper">
                          <p>
                            {{ m.name }}
                          </p>

                          <section
                            class="tasks-buttons"
                            v-if="
                              !isInputDisabled('rented_mechanization_section')
                            "
                          >
                            <div v-if="m.tasks.length" class="add-remove">
                              <span class="mck" @click="removeTask(m)">s</span>
                              <span class="number">{{ m.tasks.length }}</span>
                              <span class="mck" @click="addTask(m)">t</span>
                            </div>

                            <span
                              title="Добави подзадачи и дейности"
                              class="mck toggle-tasks"
                              v-if="!m.tasks.length"
                              @click="addTask(m)"
                              >v</span
                            >
                          </section>
                        </div>
                        <SelectHour
                          v-model="m.startHour"
                          :end="m.endHour"
                          :disabled="
                            isInputDisabled('rented_mechanization_section')
                          "
                          :filters="
                            getSameItemFilters('rentedMechanizations', index)
                          "
                          @change="changeRentedMechanization(index)"
                        />
                        <SelectHour
                          v-model="m.endHour"
                          :disabled="
                            isInputDisabled('rented_mechanization_section')
                          "
                          :start="m.startHour"
                          :filters="
                            getSameItemFilters('rentedMechanizations', index)
                          "
                          :skipFirst="true"
                          @change="changeRentedMechanization(index)"
                        />
                      </td>
                      <div v-if="m.tasks.length" class="tasks">
                        <p>ПОДЗАДАЧИ И ДЕЙНОСТИ</p>

                        <div
                          v-for="(t, i) of m.tasks"
                          :key="`${t}-${i}`"
                          class="tasks-input-wrapper"
                        >
                          <span class="number">{{ i + 1 }}</span>
                          <input
                            v-model="t.name"
                            :disabled="
                              isInputDisabled('rented_mechanization_section')
                            "
                            placeholder="Описание на задачата"
                            type="text"
                          />
                          <section class="tasks-hours-selection">
                            <SelectHour
                              v-model="t.startHour"
                              :start="m.startHour"
                              :disabled="
                                isInputDisabled('rented_mechanization_section')
                              "
                              :end="t.endHour"
                              :filters="[
                                {
                                  to: i ? m.tasks[i - 1].endHour : m.startHour,
                                },
                                {
                                  from: m.endHour,
                                },
                              ]"
                              @change="changeRentedMechanization(index)"
                              :taskHoursFirst="!i"
                              taskHours="true"
                            />
                            <SelectHour
                              v-model="t.endHour"
                              :disabled="
                                !t.startHour ||
                                isInputDisabled('rented_mechanization_section')
                              "
                              :start="t.startHour"
                              :filters="[
                                { to: m.startHour },
                                {
                                  from: m.tasks[i + 1]
                                    ? m.tasks[i + 1].startHour
                                    : m.endHour,
                                },
                              ]"
                              :skipFirst="true"
                              @change="changeRentedMechanization(index)"
                              taskHours="true"
                            />
                          </section>
                        </div>
                      </div>
                      <td
                        class="ma-cell ma-cell-nowrap padding-right"
                        v-if="report.initAsPlanned && !report.planned"
                      >
                        {{ m.plannedItems || 0 }} {{ m.unit }}
                      </td>
                      <td class="ma-cell ma-cell-nowrap">
                        <div class="input-and-percent-wrapper">
                          <div>
                            <input
                              class="ma-cell-input"
                              v-model="m.items"
                              :disabled="
                                isInputDisabled('rented_mechanization_section')
                              "
                              @keyup="changeRentedMechanization(index)"
                              type="number"
                              min="0"
                            />
                            {{ m.unit }}
                          </div>
                          <PercentTag
                            v-if="report.initAsPlanned && !report.planned"
                            :planned="m.plannedItems"
                            :real="m.items"
                          />
                        </div>
                      </td>
                      <template v-if="accessCache['prices']">
                        <td class="ma-cell ma-cell-nowrap">
                          <input
                            class="ma-cell-input"
                            v-model="m.price"
                            :disabled="isInputDisabled('prices')"
                            @keyup="changeRentedMechanization(index)"
                            type="number"
                            min="0"
                          />
                          €
                        </td>
                        <td class="ma-cell ma-cell-nowrap">
                          {{ (+m.items * +m.price).toFixed(2) }} €
                        </td>
                      </template>
                    </tr>
                  </template>
                  <tr class="tr-totals" v-if="accessCache['prices']">
                    <td
                      :colspan="report.initAsPlanned && !report.planned ? 4 : 3"
                    >
                      <p>Разход за наета механизация:</p>
                    </td>
                    <td>
                      <p class="tr-totals__expense">
                        {{ getTotals("rentedMechanizations").toFixed(2) }} €
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- MATERIALS -->
          <div
            class="new-content-data-item expense"
            v-if="canSeeContent('materials_section')"
          >
            <div v-if="viewLists()" class="new-content-data-item-content">
              <table>
                <thead
                  class="new-content-data-item-toggle desktop"
                  @click="openAddMaterialsModal()"
                >
                  <tr title="Редакция на материали">
                    <td>
                      Материали
                      <router-link
                        v-if="!isInputDisabled('materials_section')"
                        class="link"
                        :to="`/companies/${report.company._id}/${report.project._id}?openModal=materials`"
                        target="_blank"
                        @click.native="$event.stopImmediatePropagation()"
                        >Редакция в проекта</router-link
                      >
                    </td>
                    <td>
                      <span class="desktop">Количество</span>
                    </td>
                    <template v-if="accessCache['prices']">
                      <td>
                        <span class="desktop">Ед. Цена</span>
                      </td>
                      <td>
                        <span class="desktop">Сума</span>
                      </td>
                    </template>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!report.materials.length">
                    <td></td>
                  </tr>
                  <template v-for="(material, index) in report.materials">
                    <tr
                      :key="`addedReportPart-${index}`"
                      v-if="
                        (report.materials[index - 1]
                          ? report.materials[index - 1].part !== material.part
                          : true) && material.part
                      "
                      class="part-tr"
                    >
                      <td>
                        <span class="part-name-span"
                          >ЧАСТ {{ material.part }}</span
                        >
                      </td>
                      <template v-if="accessCache['prices']">
                        <td></td>
                        <td></td>
                        <!-- <td v-if="report.initAsPlanned && !report.planned"></td> -->
                        <td>
                          <p>
                            {{
                              getTotals("materials", material.part).toFixed(2)
                            }}
                            €
                          </p>
                        </td>
                      </template>
                    </tr>
                    <tr :key="`addedReportMaterial-${index}-${material.name}`">
                      <td
                        class="ma-cell no-user-select"
                        :class="{ 'ma-cell-additional': material.isAdditional }"
                      >
                        <!-- ma-cell-name -->
                        <!-- <span class="mck" v-if="material.isAdditional">G</span> -->
                        <span
                          title="Изберете дали материала да се вижда или не в Отчета към външните потребители"
                          @click="
                            changeVisibleState(material, 'materials_section')
                          "
                          class="mck icon-notVisible"
                          :class="{ 'icon-isVisible': material.isVisible }"
                          >{{ material.isVisible ? "r" : "q" }}</span
                        >
                        {{ material.name }}
                      </td>
                      <td class="ma-cell ma-cell-nowrap">
                        <div class="input-and-percent-wrapper">
                          <div>
                            <input
                              class="ma-cell-input"
                              v-model="material.items"
                              :disabled="isInputDisabled('materials_section')"
                              @keyup="changeField('materials', index)"
                              type="number"
                              min="0"
                            />
                            {{ material.unit }}
                          </div>
                        </div>
                      </td>
                      <template v-if="accessCache['prices']">
                        <td class="ma-cell ma-cell-nowrap">
                          <input
                            class="ma-cell-input"
                            :disabled="isInputDisabled('prices')"
                            v-model="material.price"
                            @keyup="changeField('materials', index)"
                            type="number"
                            min="0"
                          />
                          €
                        </td>
                        <td class="ma-cell ma-cell-nowrap">
                          {{ (+material.items * +material.price).toFixed(2) }}
                          €
                        </td>
                      </template>
                    </tr>
                  </template>
                  <tr class="tr-totals" v-if="accessCache['prices']">
                    <td colspan="3">
                      <p>Разход за материали:</p>
                    </td>
                    <td>
                      <p class="tr-totals__expense">
                        {{ getTotals("materials").toFixed(2) }} €
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- ACTIVITIES -->
          <div
            class="new-content-data-item income"
            v-if="canSeeContent('activities_section')"
          >
            <div v-if="viewLists()" class="new-content-data-item-content">
              <table>
                <thead
                  class="new-content-data-item-toggle desktop"
                  @click="openAddActivitiesModal()"
                >
                  <tr title="Редакция на дейности">
                    <td>
                      Дейности
                      <router-link
                        v-if="!isInputDisabled('activities_section')"
                        class="link"
                        :to="`/companies/${report.company._id}/${report.project._id}?openModal=activities`"
                        target="_blank"
                        @click.native="$event.stopImmediatePropagation()"
                        >Редакция в проекта</router-link
                      >
                    </td>
                    <td
                      class="padding-right"
                      v-if="report.initAsPlanned && !report.planned"
                    >
                      <span class="desktop">Планирани</span>
                    </td>
                    <td>
                      <span class="desktop">
                        <template v-if="report.planned">Планирани</template>
                        <template v-else>Отчетени</template>
                      </span>
                    </td>
                    <template v-if="accessCache['prices']">
                      <td>
                        <span class="desktop">Ед. Цена</span>
                      </td>
                      <td>
                        <span class="desktop">Приход</span>
                      </td>
                      <td>
                        <span class="desktop">Разход</span>
                      </td>
                      <td>
                        <span class="desktop">Баланс</span>
                      </td>
                    </template>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!report.activities.length">
                    <td></td>
                  </tr>
                  <template v-for="(activity, index) in report.activities">
                    <tr
                      :key="`addedReportPart-${index}`"
                      v-if="
                        (report.activities[index - 1]
                          ? report.activities[index - 1].part !== activity.part
                          : true) && activity.part
                      "
                      class="part-tr"
                    >
                      <td>
                        <span class="part-name-span"
                          >ЧАСТ {{ activity.part }}</span
                        >
                      </td>
                      <template v-if="accessCache['prices']">
                        <td></td>
                        <td></td>
                        <td v-if="report.initAsPlanned && !report.planned"></td>
                        <td>
                          <p>
                            {{
                              getTotals("activities", activity.part).toFixed(2)
                            }}
                            €
                          </p>
                        </td>
                        <td>
                          <p>
                            {{ getExpensesForPart(activity.part).toFixed(2) }}
                            €
                          </p>
                        </td>
                        <td>
                          <p>
                            {{ getProfitForPart(activity.part).toFixed(2) }} €
                          </p>
                        </td>
                      </template>
                    </tr>
                    <tr :key="`addedReportActivity-${index}-${activity.name}`">
                      <td
                        class="ma-cell ma-cell-name"
                        :class="{ 'ma-cell-additional': activity.isAdditional }"
                      >
                        {{ activity.name }}
                        <span class="mck" v-if="activity.isAdditional">O</span>
                      </td>
                      <td
                        class="ma-cell ma-cell-nowrap padding-right"
                        v-if="report.initAsPlanned && !report.planned"
                      >
                        {{ activity.plannedItems || 0 }} {{ activity.unit }}
                      </td>
                      <td class="ma-cell ma-cell-nowrap">
                        <div class="input-and-percent-wrapper">
                          <div>
                            <input
                              class="ma-cell-input"
                              v-model="activity.items"
                              :disabled="isInputDisabled('activities_section')"
                              @keyup="changeField('activities', index)"
                              type="number"
                              min="0"
                            />
                            {{ activity.unit }}
                          </div>
                          <PercentTag
                            v-if="report.initAsPlanned && !report.planned"
                            :planned="activity.plannedItems"
                            :real="activity.items"
                            :red="activity.plannedItems > activity.items"
                          />
                        </div>
                      </td>
                      <template v-if="accessCache['prices']">
                        <td class="ma-cell ma-cell-nowrap">
                          <input
                            class="ma-cell-input"
                            :disabled="isInputDisabled('prices')"
                            v-model="activity.price"
                            @keyup="changeField('activities', index)"
                            type="number"
                            min="0"
                          />
                          €
                        </td>
                        <td class="ma-cell ma-cell-nowrap">
                          {{ (+activity.items * +activity.price).toFixed(2) }}
                          €
                        </td>
                        <td>{{ getExpense(activity).toFixed(2) }} €</td>
                        <td>{{ getProfit(activity).toFixed(2) }} €</td>
                      </template>
                    </tr>
                  </template>
                  <tr class="tr-totals" v-if="accessCache['prices']">
                    <td
                      :colspan="report.initAsPlanned && !report.planned ? 4 : 3"
                    >
                      <p>Общо:</p>
                    </td>
                    <td>
                      <p class="tr-totals__income">
                        {{ getTotals("activities").toFixed(2) }} €
                      </p>
                    </td>
                    <td>
                      <p class="tr-totals__expense">
                        {{ getExpenses().toFixed(2) }} €
                      </p>
                    </td>
                    <td>
                      <p class="tr-totals__balance">
                        {{ getTotalProfit().toFixed(2) }} €
                      </p>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <!-- <div class="total-wrapper total-wrapper--red">
            <span>ОБЩО РАЗХОДИ ЗА ЦЕЛИЯ ОТЧЕТ</span>
            <span>{{ getExpenses().toFixed(2) }} €</span>
          </div>
          <div class="total-wrapper total-wrapper--green">
            <span>ОБЩО ПРИХОДИ ЗА ЦЕЛИЯ ОТЧЕТ</span>
            <span>{{ getTotals('activities').toFixed(2) }} €</span>
          </div>
          <div class="total-wrapper">
            <span>БАЛАНС</span>
            <span>{{ getTotalProfit().toFixed(2) }} €</span>
          </div> -->

          <!-- INVENTORY BOTTOM -->
          <div
            class="new-content-data-item inventory"
            v-if="
              !this.report.isSelfReport &&
              (selectedProject !== undefined ||
                this.$route.name === 'editReport')
            "
          >
            <div v-if="viewLists()" class="new-content-data-item-content">
              <table>
                <thead class="new-content-data-item-toggle desktop">
                  <tr>
                    <td>
                      Инвентар/Инструменти/Строителна техника към този обект
                    </td>
                  </tr>
                </thead>
                <tbody>
                  <tr v-if="!report.inventories.length">
                    <td></td>
                  </tr>
                  <template v-for="(i, index) in report.inventories">
                    <tr :key="`inventory-${index}`">
                      <td class="ma-cell ma-cell-name">
                        {{ i.name }}
                      </td>
                    </tr>
                  </template>
                </tbody>
              </table>
            </div>
          </div>

          <div
            class="invalid-report-wrap"
            v-if="this.$route.name === 'editReport' && !report.planned"
          >
            <p>
              <strong>Маркиране на отчет като сгрешен</strong> - ако смятате, че
              сте объркали данните в отчета, го отбележете като грешен. Ще бъде
              видим, но няма да се зачита.
            </p>
            <div class="switch-wrapper">
              <div class="switch-container">
                <label class="switch">
                  <input
                    type="checkbox"
                    v-model="report.isInvalid"
                    @change="reportChanged()"
                    :disabled="!allowSave"
                  />
                  <span class="slider"></span>
                </label>
              </div>
              <label class="switch-label" @click="report.isInvalid = true">
                <img
                  v-if="report.isInvalid"
                  class="flag"
                  src="../assets/img/flag_yes.svg"
                  alt="Invalid"
                />
                <img
                  v-else
                  class="flag"
                  src="../assets/img/flag_no.svg"
                  alt="Valid"
                />
                Грешен отчет
              </label>
            </div>
          </div>
        </div>
        <!-- NEW USER BUTTONS MOBILE -->
        <div class="btns mobile" v-if="allowSave">
          <button class="btn btn-close" @click="cancelReport()">
            <span class="mck">F</span>
            Отказ
          </button>
          <button class="btn btn-new" @click="save()">
            <span class="mck">Y</span>
            Запис
          </button>
        </div>
      </div>
    </div>
    <div class="new-wrapper new-wrapper--content" v-else>
      <img class="help-img" src="../assets/img/helpReports.svg" />
    </div>
    <!-- ADD WORKERS/MATERIALS/ACTIVITIES/MECHANIZATIONS MODALS -->
    <transition name="fade">
      <AddUsersModal
        v-if="isAddUsersModalOpened"
        :isComingFromReport="true"
        :incomingUsers="report.workers"
        :date="report.date"
        :usersType="'workers'"
        :parts="getParts()"
      />
    </transition>
    <transition name="fade">
      <AddMaterialsModal
        v-if="isAddMaterialsModalOpened"
        :isComingFromReport="true"
        :companyId="report.company._id"
        :projectId="report.project._id"
        :incomingMaterials="selectedProject.materials"
        :newestMaterial="newestMaterial"
        :parts="getParts()"
      />
    </transition>
    <transition name="fade">
      <AddActivitiesModal
        v-if="isAddActivitiesModalOpened"
        :isComingFromReport="true"
        :companyId="report.company._id"
        :projectId="report.project._id"
        :incomingActivities="selectedProject.activities"
        :newestActivity="newestActivity"
        :parts="getParts()"
      />
    </transition>
    <transition name="fade">
      <AddMechanizationsModal
        v-if="isAddMechanizationsModalOpened"
        :isComingFromReport="true"
        :companyId="report.company._id"
        :projectId="report.project._id"
        :incomingMechanizations="selectedProject.mechanizations"
        :reportedMechanizations="report.mechanizations"
        :newestMechanization="newestMechanization"
        :parts="getParts()"
      />
    </transition>
    <transition name="fade">
      <AddMechanizationsModal
        v-if="isAddRentedMechanizationsModalOpened"
        :isComingFromReport="true"
        :companyId="report.company._id"
        :projectId="report.project._id"
        :incomingMechanizations="selectedProject.rentedMechanizations"
        :reportedMechanizations="report.rentedMechanizations"
        :newestMechanization="newestRentedMechanization"
        :parts="getParts()"
        rented="true"
      />
    </transition>
    <transition name="fade">
      <UnsavedChangesModal v-if="isUnsavedChangesModalOpened" />
    </transition>
    <transition name="slide-bottom">
      <ConvertPlannedToRealReport
        v-if="isConvertPlannedToRealReportOpen"
        :report="report"
        @get-report="getReport(), (flash = true)"
        @get-report-moved="getReport()"
      />
    </transition>
  </div>
</template>

<script>
import hours from "./mixins/hours.js";
import AddUsersModal from "./shared/AddUsersModal";
import AddMaterialsModal from "./shared/AddMaterialsModal";
import AddActivitiesModal from "./shared/AddActivitiesModal";
import AddMechanizationsModal from "./shared/AddMechanizationsModal";
import UnsavedChangesModal from "./shared/UnsavedChangesModal";
import ConvertPlannedToRealReport from "./shared/ConvertPlannedToRealReport";
import SelectHour from "./shared/SelectHour";
import WorktimeTag from "./shared/WorktimeTag";
import PercentTag from "./shared/PercentTag";
import { mapGetters } from "vuex";
import Datepicker from "vuejs-datepicker";
import { bg } from "vuejs-datepicker/dist/locale";
import log from "./mixins/log.js";
import { getAccess } from "./mixins/getAccess.js";
import tabsData from "../data/tabsData.js";
import TheInput from "@/components/TheInput";
import { format } from "date-fns";

export default {
  components: {
    AddUsersModal: AddUsersModal,
    AddMaterialsModal: AddMaterialsModal,
    AddActivitiesModal: AddActivitiesModal,
    AddMechanizationsModal: AddMechanizationsModal,
    UnsavedChangesModal: UnsavedChangesModal,
    ConvertPlannedToRealReport: ConvertPlannedToRealReport,
    Datepicker: Datepicker,
    SelectHour: SelectHour,
    WorktimeTag: WorktimeTag,
    PercentTag: PercentTag,
    TheInput,
  },
  mixins: [hours, log],
  watch: {
    "report.date"(to) {
      if (!this.report._id) {
        if (this.report.planned) {
          if (to.getTime() < this.today.getTime()) {
            var tomorrow = new Date();
            tomorrow.setDate(tomorrow.getDate() + 1);
            this.report.date = tomorrow;
            this.$snotify.error(
              "Не можете да създавате планиране с минала дата!"
            );
          }
        } else {
          if (!(to.getTime() < this.today.getTime())) {
            this.report.date = new Date();
            this.$snotify.error("Не можете да създавате отчети с бъдеща дата!");
          }
        }
      }

      this.formatedDate= format(new Date(this.report.date), 'dd/MM/yyyy')
    },
  },
  data() {
    return {
      tabsData,
      // Vars for select v-model
      company: "",
      project: "",
      isReportChanged: false,
      // Vars for date picker
      bg: bg,
      formatedDate: "",
      today: undefined,
      // А boolean for every dropdown in the template
      openedDropdown: [false, false, false, false, false, false, false],
      // A boolean for the modal for workers selection
      isAddUsersModalOpened: false,
      isAddMaterialsModalOpened: false,
      isAddActivitiesModalOpened: false,
      isAddMechanizationsModalOpened: false,
      isAddRentedMechanizationsModalOpened: false,
      isUnsavedChangesModalOpened: false,
      isConvertPlannedToRealReportOpen: false,
      flash: false,
      // SEARCH
      searchCompanies: "",
      searchProjects: "",
      // The main company project
      companies: [],
      latestCompanies: [{ company: { _id: "", companyName: "" } }],
      newestMaterial: "",
      newestActivity: "",
      newestMechanization: "",
      newestRentedMechanization: "",
      projects: [],
      parts: [],
      accessCache: {},
      selectedProject: undefined,
      allowSave: true,
      saving: false,
      // The main report project
      report: {
        date: undefined,
        planned: false,
        overtime: false,
        createdBy: {
          _id: "",
          name: "",
        },
        company: {
          _id: "",
          companyName: "",
        },
        project: {
          _id: "",
          projectName: "",
        },
        isInvalid: false,
        allVisible: true,
        workers: [],
        materials: [],
        activities: [],
        mechanizations: [],
        rentedMechanizations: [],
        inventories: [],
        tools: [],
      },
    };
  },
  computed: {
    ...mapGetters(["getUser"]),
  },
  methods: {
    getItemName(item) {
      if (this.report.inventories) {
        const inventory = this.report.inventories.find(
          (i) => i._id === item._id
        );

        if (inventory) {
          // let name = inventory.name;
          // if (inventory.brand) name += ` - ${inventory.brand}`;
          // if (inventory.serialNumber) name += ` - ${inventory.serialNumber}`;
          return `${inventory.name} / ${inventory.brand || '-'} / ${inventory.serialNumber || '-'}`;
        }
      }

      return item.name;
    },
    addTask(m) {
      if (m.tasks.length) {
        if (
          !m.tasks[m.tasks.length - 1].startHour ||
          !m.tasks[m.tasks.length - 1].endHour
        )
          return this.$snotify.warning(
            "Трябва да изберете време 'от-до' на задачата!"
          );
        if (m.tasks[m.tasks.length - 1].endHour === m.endHour) {
          return this.$snotify.warning("Периодът е запълнен!");
        }
      }

      if (m.tasks) m.tasks.push({});
    },
    isInputDisabled(field) {
      return this.accessCache[field] !== "edit";
    },
    async setSelfReportStatus(v) {
      let worker = this.report.workers[0];
      if (v && !worker.part)
        return this.$snotify.warning("Трябва да изберете част първо");

      try {
        this.report.isSelfReportConfirmed = v;
        this.report.checkedBy = this.getUser._id;
        let url = `${process.env.VUE_APP_BASE_URI}/report/${this.report._id}`;

        await this.$http.put(url, this.report);
        this.getReport();
      } catch (err) {
        console.log(err);
      }
    },
    canSeeContent(content) {
      // can see only workers in self reports
      if (this.report.isSelfReport) {
        if (content === "worker_section") return true;
        else return false;
      }

      const baseCondition =
        this.selectedProject !== undefined || this.$route.name === "editReport";

      if (!baseCondition) return false;
      if (content) return this.accessCache[content];
      return true;
    },
    removeTask(m) {
      m.tasks.splice(m.tasks.length - 1, 1);
    },
    // Open dropdown. Depends on index (hard coded in template)
    openDropdown(i) {
      this.$set(this.openedDropdown, i, true);
    },
    // Close dropdown. Depends on index (hard coded in template)
    closeDropdown(i) {
      setTimeout(() => {
        this.$set(this.openedDropdown, i, false);
      }, 100);
    },
    // SELECTING
    // 1 - SELECT COMPANY BY ID
    selectCompany(company) {
      this.resetSelectedProject();
      this.report.company = company;
    },
    // 2 - SELECT THE INDEX OF A 'PROJECT' INSIDE COMPANY
    selectProject(project) {
      this.report.project = project;
      this.getSelectedProject(project._id);
      this.getInventories();
    },
    // RESET SELECTED AND EVERYTHING NESTED INSIDE ON FOCUS
    resetSelectedCompany() {
      this.report.company = {
        _id: "",
        companyName: "",
      };
      this.searchCompanies = "";
      this.company = "";
      this.resetSelectedProject();
    },
    resetSelectedProject() {
      this.projects = [];
      this.searchProjects = "";
      this.report.project = {
        _id: "",
        projectName: "",
      };
      this.selectedProject = undefined;
      this.report.workers = [];
      this.report.materials = [];
      this.report.activities = [];
      this.report.mechanizations = [];
      this.report.rentedMechanizations = [];
      this.project = "";
    },
    // FILTERED RESULTS WHEN SEARCHING
    filteredCompanies() {
      if (this.companies.length) {
        return this.companies.filter((c) => {
          return c.companyName
            .toLowerCase()
            .includes(this.searchCompanies.toLowerCase());
        });
      }
    },
    filteredProjects() {
      if (this.report.company._id && this.projects.length) {
        return this.projects.filter((p) => {
          return p.projectName
            .toLowerCase()
            .includes(this.searchProjects.toLowerCase());
        });
      }
    },
    // We have a selected workers, materials, activities OR mechanizations at least and change styles in template
    viewLists() {
      return (
        this.report.workers.length ||
        this.report.materials.length ||
        this.report.activities.length ||
        this.report.mechanizations.length ||
        this.report.tools.length ||
        this.report.rentedMechanizations.length
      );
    },
    // checks if there is at least 1 visile resource in the report so it can send mail
    checkIsvisible() {
      let size = 0;

      if (this.report.workers.length) {
        this.report.workers.forEach((x) => {
          if (x.isVisible) size++;
        });
      }
      if (this.report.mechanizations.length) {
        this.report.mechanizations.forEach((x) => {
          if (x.isVisible) size++;
        });
      }
      if (this.report.rentedMechanizations.length) {
        this.report.rentedMechanizations.forEach((x) => {
          if (x.isVisible) size++;
        });
      }
      if (this.report.materials.length) {
        this.report.materials.forEach((x) => {
          if (x.isVisible) size++;
        });
      }

      return size && this.report.allVisible;
    },
    toggleAllVisible() {
      if (!this.selectedProject.isExternal) {
        return this.$snotify.warning("Избраният проект е вътрешен");
      }

      this.$set(this.report, "allVisible", !this.report.allVisible);

      if (this.report.workers.length) {
        this.report.workers.map((x) =>
          this.changeVisibleState(x, "worker_section", this.report.allVisible)
        );
      }
      if (this.report.mechanizations.length) {
        this.report.mechanizations.map((x) =>
          this.changeVisibleState(x, "tools_section", this.report.allVisible)
        );
      }
      if (this.report.rentedMechanizations.length) {
        this.report.rentedMechanizations.map((x) =>
          this.changeVisibleState(
            x,
            "rented_mechanization_section",
            this.report.allVisible
          )
        );
      }
      if (this.report.materials.length) {
        this.report.materials.map((x) =>
          this.changeVisibleState(
            x,
            "materials_section",
            this.report.allVisible
          )
        );
      }
    },
    changeVisibleState(p, field, state) {
      if (this.accessCache[field] === "edit") {
        if (!this.selectedProject.isExternal) {
          return this.$snotify.warning("Избраният проект е вътрешен");
        }
        this.$set(
          p,
          "isVisible",
          typeof state === "boolean" ? state : !p.isVisible
        );
      }
    },
    deleteItem(x, i) {
      this.report[x].splice(i, 1);
      this.reportChanged();
    },
    getTotalWorkers(part) {
      let total = 0;
      for (let x of this.report.workers) {
        if (part) {
          if (x.part === part) {
            total += x.total || 0;
          }
        } else {
          total += x.total || 0;
        }
      }

      if (!part) {
        if (!this.report.totals) {
          this.$set(this.report, "totals", {});
        }

        this.$set(this.report.totals, "workers", total);
      }
      return total;
    },
    getWorkerCost(w, h) {
      let rate = 0;

      if (w.position) {
        rate = w.position.rate || 0;
      }

      const hours = h.total || 0;
      this.$set(w, "total", rate * hours);
      return rate * hours;
    },
    getTotals(type, part) {
      let total = 0;
      for (let x of this.report[type]) {
        if (part) {
          if (x.part === part) {
            total += x.items * x.price || 0;
          }
        } else {
          total += x.items * x.price || 0;
        }
      }

      if (!part) {
        if (!this.report.totals) {
          this.$set(this.report, "totals", {});
        }

        this.$set(this.report.totals, type, total);
      }

      return total;
    },
    getTotalProfit() {
      const t = this.getTotals("activities") || 0;
      const e = this.getExpenses() || 0;

      const total = t - e;

      if (!this.report.totals) {
        this.$set(this.report, "totals", {});
      }

      this.$set(this.report.totals, "profit", total);
      return total;
    },
    getExpense(a) {
      let e = 0;
      const total = +a.items * +a.price;
      const totalForPart = this.getExpensesForPart(a.part);
      const totalForActivityPart = this.getTotals("activities", a.part);

      e =
        totalForPart *
        ((total ? total : 1) /
          (totalForActivityPart ? totalForActivityPart : 1));

      this.$set(a, "expense", e);
      return e;
    },
    getExpensesForPart(p) {
      let e = 0;

      e += this.getTotalWorkers(p);
      e += this.getTotals("mechanizations", p);
      e += this.getTotals("rentedMechanizations", p);
      e += this.getTotals("materials", p);

      return e;
    },
    getProfit(a) {
      let profit = 0;

      const total = +a.items * +a.price;
      const expense = this.getExpense(a);

      profit = total - expense;

      this.$set(a, "profit", profit);
      return profit;
    },
    getProfitForPart(p) {
      let profit = 0;

      const totalForPart = this.getExpensesForPart(p);
      const totalForActivityPart = this.getTotals("activities", p);

      profit = totalForActivityPart - totalForPart;

      return profit;
    },
    getExpenses() {
      let total = 0;

      total += this.report.totals.workers;
      total += this.report.totals.mechanizations;
      total += this.report.totals.rentedMechanizations;
      total += this.report.totals.tools;
      total += this.report.totals.materials;

      if (!this.report.totals) {
        this.$set(this.report, "totals", {});
      }

      this.$set(this.report.totals, "expenses", total);

      return total;
    },
    getSameItemFilters(x, i) {
      const items = this.report[x].filter((w, j) => {
        return w._id === this.report[x][i]._id && i !== j;
      });

      // const filter
      return items
        .map((item) => {
          return item.startHour || item.endHour
            ? {
                from: item.startHour,
                to: item.endHour,
              }
            : null;
        })
        .filter((item) => item);
    },
    getParts() {
      for (let m of this.selectedProject.mechanizations) {
        if (m.part) {
          if (this.parts.indexOf(m.part) === -1) {
            this.parts.push(m.part);
          }
        }
      }
      for (let m of this.selectedProject.rentedMechanizations) {
        if (m.part) {
          if (this.parts.indexOf(m.part) === -1) {
            this.parts.push(m.part);
          }
        }
      }
      for (let m of this.selectedProject.materials) {
        if (m.part) {
          if (this.parts.indexOf(m.part) === -1) {
            this.parts.push(m.part);
          }
        }
      }
      for (let mh of this.selectedProject.manHours) {
        if (mh.part) {
          if (this.parts.indexOf(mh.part) === -1) {
            this.parts.push(mh.part);
          }
        }
      }
      for (let a of this.selectedProject.activities) {
        if (a.part) {
          if (this.parts.indexOf(a.part) === -1) {
            this.parts.push(a.part);
          }
        }
      }
      if (this.selectedProject.parts) {
        for (let p of this.selectedProject.parts) {
          if (p.name) {
            if (this.parts.indexOf(p.name) === -1) {
              this.parts.push(p.name);
            }
          }
        }
      }

      return this.parts.slice().sort();
    },
    resetWorkerHours(w) {
      w.startHour = null;
      w.endHour = null;
      w.startHourDate = null;
      w.endHourDate = null;
    },
    restoreWorkerHours(w) {
      w.startHour = w.plannedStartHour;
      w.endHour = w.plannedEndHour;
    },
    // If we get the 'saveWorkersModal' event, we assign the workers we receive to the report
    handleWorkers(workers) {
      // this.report.workers = [];

      for (let w of workers) {
        if (this.report.workers.map((rw) => rw._id).indexOf(w._id) < 0) {
          if (!w.startHour && !w.endHour) {
            this.$set(w, "startHour", "08:00");
            this.$set(w, "endHour", "17:00");
          }
        }
        if (!w.tasks) this.$set(w, "tasks", []);
        if (typeof w.isVisible !== "boolean")
          this.$set(
            w,
            "isVisible",
            typeof w.isVisibleMain === "boolean"
              ? w.isVisibleMain
              : this.report.allVisible
          );
        this.report.workers.push(Object.assign({}, w));
      }

      this.report.workers = this.report.workers.sort((a, b) =>
        a.part > b.part ? 1 : -1
      );

      this.closeAddWorkersModal();
      this.reportChanged();
    },
    handleMaterials(materials) {
      this.selectedProject.materials.forEach((m) => {
        if (m.isSelected) {
          m.isSelected = false;
        }
      });
      // Items are zero by default
      materials.forEach((m) => {
        if (m.items === undefined) {
          m.items = 0;
        }
        if (typeof m.isVisible !== "boolean")
          this.$set(m, "isVisible", this.report.allVisible);
        // add a temporary id just to know that the material is a new one
        // the tempId will be removed before sent
        if (m.isAdditional && !m._id) {
          const now = new Date();
          m._id = `${Math.random().toString(36).substr(2, 9)}-${now.getTime()}`;
          this.selectedProject.materials.unshift(m);
          m.tempId = true;
        }
      });

      this.report.materials = materials.sort((a, b) =>
        a.part > b.part ? 1 : -1
      );

      this.updateMaterials();
      this.closeAddMaterialsModal();
      this.reportChanged();
    },
    handleActivities(activities) {
      this.selectedProject.activities.forEach((a) => {
        if (a.isSelected) {
          a.isSelected = false;
        }
      });
      // Items are zero by default
      activities.forEach((a) => {
        if (a.items === undefined) {
          a.items = 0;
        }
        // add a temporary id just to know that the activity is a new one
        // the tempId will be removed before sent
        if (a.isAdditional && !a._id) {
          const now = new Date();
          a._id = `${Math.random().toString(36).substr(2, 9)}-${now.getTime()}`;
          this.selectedProject.activities.unshift(a);
          a.tempId = true;
        }
      });
      this.report.activities = activities.sort((a, b) =>
        a.part > b.part ? 1 : -1
      );

      this.updateActivities();
      this.closeAddActivitiesModal();
      this.reportChanged();
    },
    handleMechanizations(mechanizations) {
      // this.selectedProject.mechanizations.forEach((m) => {
      //   if (m.isSelected) {
      //     m.isSelected = false;
      //   }
      // });
      // Items are zero by default
      mechanizations.forEach((m) => {
        if (m.items === undefined) {
          m.items = 1;
        }

        if (this.report.mechanizations.map((rm) => rm._id).indexOf(m._id) < 0) {
          if (!m.startHour && !m.endHour) {
            this.$set(m, "startHour", "08:00");
            this.$set(m, "endHour", "17:00");
          }
        }
        if (!m.tasks) this.$set(m, "tasks", []);
        if (typeof m.isVisible !== "boolean")
          this.$set(m, "isVisible", this.report.allVisible);

        // add a temporary id just to know that the mechanization is a new one
        // the tempId will be removed before sent
        if (m.isAdditional && !m._id) {
          const now = new Date();
          m._id = `${Math.random().toString(36).substr(2, 9)}-${now.getTime()}`;
          this.selectedProject.mechanizations.unshift(m);
          m.tempId = true;
        }

        this.report.mechanizations.push(m);
      });
      this.report.mechanizations = this.report.mechanizations.sort((a, b) =>
        a.part > b.part ? 1 : -1
      );
      this.updateMechanizations();
      this.closeAddMechanizationsModal();
      this.reportChanged();
    },
    handleRentedMechanizations(rentedMechanizations) {
      this.selectedProject.rentedMechanizations.forEach((m) => {
        if (m.isSelected) {
          m.isSelected = false;
        }
      });
      // Items are zero by default
      rentedMechanizations.forEach((m) => {
        if (m.items === undefined) {
          m.items = 1;
        }
        if (
          this.report.rentedMechanizations.map((rm) => rm._id).indexOf(m._id) <
          0
        ) {
          if (!m.startHour && !m.endHour) {
            this.$set(m, "startHour", "08:00");
            this.$set(m, "endHour", "17:00");
          }
        }
        if (!m.tasks) this.$set(m, "tasks", []);
        if (typeof m.isVisible !== "boolean")
          this.$set(m, "isVisible", this.report.allVisible);
        // add a temporary id just to know that the mechanization is a new one
        // the tempId will be removed before sent
        if (m.isAdditional && !m._id) {
          const now = new Date();
          m._id = `${Math.random().toString(36).substr(2, 9)}-${now.getTime()}`;
          this.selectedProject.rentedMechanizations.unshift(m);
          m.tempId = true;
        }

        this.report.rentedMechanizations.push(m);
      });

      this.report.rentedMechanizations = this.report.rentedMechanizations.sort(
        (a, b) => (a.part > b.part ? 1 : -1)
      );
      this.updateRentedMechanizations();
      this.closeAddRentedMechanizationsModal();
      this.reportChanged();
    },
    openAddUsersModal() {
      if (getAccess("worker_section", "reports", true)) {
        if (
          this.allowSave &&
          (this.selectedProject !== undefined ||
            this.$route.name === "editReport")
        ) {
          this.isAddUsersModalOpened = true;
        }
      }
    },
    openAddMaterialsModal() {
      if (getAccess("materials_section", "reports", true)) {
        if (
          this.allowSave &&
          (this.selectedProject !== undefined ||
            this.$route.name === "editReport")
        ) {
          this.isAddMaterialsModalOpened = true;
        }
      }
    },
    openAddActivitiesModal() {
      if (getAccess("activities_section", "reports", true)) {
        if (
          this.allowSave &&
          (this.selectedProject !== undefined ||
            this.$route.name === "editReport")
        ) {
          this.isAddActivitiesModalOpened = true;
        }
      }
    },
    openAddMechanizationsModal() {
      if (getAccess("tools_section", "reports", true)) {
        if (
          this.allowSave &&
          (this.selectedProject !== undefined ||
            this.$route.name === "editReport")
        ) {
          this.isAddMechanizationsModalOpened = true;
        }
      }
    },
    openAddRentedMechanizationsModal() {
      if (getAccess("rented_mechanization_section", "reports", true)) {
        if (
          this.allowSave &&
          (this.selectedProject !== undefined ||
            this.$route.name === "editReport")
        ) {
          this.isAddRentedMechanizationsModalOpened = true;
        }
      }
    },
    // Close the workers modal
    closeAddWorkersModal() {
      this.isAddUsersModalOpened = false;
    },
    closeAddMaterialsModal() {
      this.isAddMaterialsModalOpened = false;
    },
    closeAddActivitiesModal() {
      this.isAddActivitiesModalOpened = false;
    },
    closeAddMechanizationsModal() {
      this.isAddMechanizationsModalOpened = false;
    },
    closeAddRentedMechanizationsModal() {
      this.isAddRentedMechanizationsModalOpened = false;
    },
    // JUST FOR THE CASE OF REACTIVITY TO WORK AND NOT USE forceUpdate()
    // changeWorker(i) {
    //   this.$set(this.report.workers, i, this.report.workers[i]);
    //   this.reportChanged();
    // },
    // changeMaterial(i) {
    //   this.$set(this.report.materials, i, this.report.materials[i]);
    //   this.reportChanged();
    // },
    // changeActivity(i) {
    //   this.$set(this.report.activities, i, this.report.activities[i]);
    //   this.reportChanged();
    // },
    // changeMechanization(i) {
    //   this.$set(this.report.mechanizations, i, this.report.mechanizations[i]);
    //   this.reportChanged();
    // },
    setInvItems(field, i) {
      if (this.report[field] && this.report[field][i]) {
        let el = this.report[field][i];
        const { startHour, endHour } = el;

        el.items = this.calculateHours(
          this.report.date,
          startHour,
          endHour
        ).total;
      }
    },
    changeField(field, i) {
      this.$set(this.report[field], i, this.report[field][i]);
      this.reportChanged();
    },
    changeRentedMechanization(i) {
      this.$set(
        this.report.rentedMechanizations,
        i,
        this.report.rentedMechanizations[i]
      );
      this.reportChanged();
    },
    updateMaterials() {
      this.report.materials.map((m) => {
        const material = this.selectedProject.materials.find((fm) => {
          return fm._id === m._id;
        });
        if (material) {
          material.isSelected = true;
          material.items = m.items;
          material.plannedItems = m.plannedItems;
          material.price = m.price;
          material.part = m.part;
        } else {
          m.isSelected = true;
          this.selectedProject.materials.unshift(m);
        }
      });
    },
    updateActivities() {
      this.report.activities.map((a) => {
        const activity = this.selectedProject.activities.find((fa) => {
          return fa._id === a._id;
        });
        if (activity) {
          activity.isSelected = true;
          activity.items = a.items;
          activity.plannedItems = a.plannedItems;
          activity.price = a.price;
          activity.part = a.part;
        } else {
          a.isSelected = true;
          this.selectedProject.activities.unshift(a);
        }
      });
    },
    updateMechanizations() {
      this.report.mechanizations.map((m, index) => {
        this.setInvItems("mechanizations", index);

        const mechanization = this.selectedProject.mechanizations.find((ma) => {
          return ma._id === m._id;
        });
        if (mechanization) {
          mechanization.isSelected = true;
          // mechanization.items = m.items;
          mechanization.plannedItems = m.plannedItems;
          mechanization.price = m.price;
          mechanization.part = m.part;
          mechanization.tasks = m.tasks;
        } else {
          m.isSelected = true;
          this.selectedProject.mechanizations.unshift(m);
        }
      });
    },
    updateTools() {
      this.report.tools.forEach((tool, index) => {
        this.setInvItems("tools", index);
      });
    },
    updateRentedMechanizations() {
      this.report.rentedMechanizations.map((m) => {
        const mechanization = this.selectedProject.rentedMechanizations.find(
          (ma) => {
            return ma._id === m._id;
          }
        );
        if (mechanization) {
          mechanization.isSelected = true;
          mechanization.items = m.items;
          mechanization.plannedItems = m.plannedItems;
          mechanization.price = m.price;
          mechanization.part = m.part;
          mechanization.landlord = m.landlord;
          mechanization.tasks = m.tasks;
        } else {
          m.isSelected = true;
          this.selectedProject.rentedMechanizations.unshift(m);
        }
      });
    },
    // GET ALL COMPANIES REQUEST
    getCompanies() {
      this.companies = [];
      let id = this.getUser._id;
      let requestUrl = `${process.env.VUE_APP_BASE_URI}/company/reporters/companies/${id}`;
      this.$http
        .get(requestUrl)
        .then((response) => {
          this.companies = response.data;
        })
        .catch((error) => console.log(error));
    },
    // GET LATEST REPORTED COMPANIES
    getLatestUsedCompanies() {
      const id = this.getUser._id;
      const url = `${process.env.VUE_APP_BASE_URI}/report/limited/${id}/5`;
      this.$http
        .get(url)
        .then((response) => {
          this.latestCompanies = response.data;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    // GET ALL VISIBLE PROJECTS INSIDE THE SELECTED COMPANY
    getProjects(autoselect) {
      this.projects = [];
      if (this.report.company._id.length) {
        let id = this.getUser._id;
        let requestUrl = `${process.env.VUE_APP_BASE_URI}/company/reporters/projects/${this.report.company._id}/${id}`;
        this.$http
          .get(requestUrl)
          .then((response) => {
            this.projects = response.data;
            if (autoselect) {
              if (this.projects.length === 1) {
                this.selectProject(this.projects[0]);
              }
            }
          })
          .catch((error) => console.log(error));
      }
    },
    // GET SPECIFIC PART BY ID REQUEST
    getSelectedProject(id) {
      this.selectedProject = undefined;
      let url = `${process.env.VUE_APP_BASE_URI}/company/project/${id}`;
      return this.$http
        .get(url)
        .then((response) => {
          this.parts = [];
          this.selectedProject = response.data[0];
          if (!this.report._id) {
            this.report.allVisible = !!this.selectedProject.isExternal;
          }
        })
        .catch((error) => console.log(error));
    },
    getMaterials() {
      let url = `${process.env.VUE_APP_BASE_URI}/company/project/${this.selectedProject._id}`;
      return this.$http
        .get(url)
        .then((response) => {
          for (let m of response.data[0].materials) {
            if (
              this.selectedProject.materials
                .map((mat) => mat._id)
                .indexOf(m._id)
            ) {
              this.newestMaterial = m._id;
              break;
            }
          }
          this.selectedProject.materials = response.data[0].materials;
          this.updateMaterials();
        })
        .catch((error) => console.log(error));
    },
    getActivities() {
      let url = `${process.env.VUE_APP_BASE_URI}/company/project/${this.selectedProject._id}`;
      return this.$http
        .get(url)
        .then((response) => {
          for (let a of response.data[0].activities) {
            if (
              this.selectedProject.activities
                .map((act) => act._id)
                .indexOf(a._id)
            ) {
              this.newestActivity = a._id;
              break;
            }
          }
          this.selectedProject.activities = response.data[0].activities;

          this.updateActivities();
        })
        .catch((error) => console.log(error));
    },
    getMechanizations() {
      let url = `${process.env.VUE_APP_BASE_URI}/company/project/${this.selectedProject._id}`;
      return this.$http
        .get(url)
        .then((response) => {
          for (let m of response.data[0].mechanizations) {
            if (
              this.selectedProject.mechanizations
                .map((mech) => mech._id)
                .indexOf(m._id)
            ) {
              this.newestMechanization = m._id;
              break;
            }
          }
          this.selectedProject.mechanizations = response.data[0].mechanizations;
          this.updateMechanizations();
        })
        .catch((error) => console.log(error));
    },
    getRentedMechanizations() {
      let url = `${process.env.VUE_APP_BASE_URI}/company/project/${this.selectedProject._id}`;
      return this.$http
        .get(url)
        .then((response) => {
          for (let m of response.data[0].rentedMechanizations) {
            if (
              this.selectedProject.rentedMechanizations
                .map((mech) => mech._id)
                .indexOf(m._id)
            ) {
              this.newestRentedMechanization = m._id;
              break;
            }
          }
          this.selectedProject.rentedMechanizations =
            response.data[0].rentedMechanizations;
          this.updateRentedMechanizations();
        })
        .catch((error) => console.log(error));
    },
    getInventories() {
      console.log("?");
      if (!this.report.project._id) return;

      let url = `${process.env.VUE_APP_BASE_URI}/inventory/${
        this.report.company._id
      }/${this.report.project._id}/${this.report.date.toISOString()}`;

      return this.$http
        .get(url)
        .then((res) => {
          res.data.forEach((e) => {
            e.tasks = [];
            e.startHour = "08:00";
            e.endHour = "17:00";
            e.price = e.hourlyRate || 0;
            e.items = this.calculateHours(
              this.report.date,
              e.startHour,
              e.endHour
            ).total;
          });

          this.$set(this.report, "inventories", res.data);
          this.$set(
            this.report,
            "mechanizations",
            res.data.filter((d) => d.type === "equipment")
          );
          this.$set(
            this.report,
            "tools",
            res.data.filter((d) => d.type !== "equipment")
          );
        })
        .catch((error) => console.log(error));
    },
    // GET SPECIFIC REPORT
    getReport() {
      const id = this.$route.params.id;
      this.isConvertPlannedToRealReportOpen = false;
      let url = `${process.env.VUE_APP_BASE_URI}/report/${id}`;
      this.$http
        .get(url)
        .then((response) => {
          this.getSelectedProject(response.data.project._id).then(() => {
            this.report = response.data;
            this.report.date = new Date(response.data.date);
            // ADD TASKS ARRAY
            this.report.workers.forEach((w) => {
              if (!w.tasks) this.$set(w, "tasks", []);
            });
            // ADD IS SELECTED PROPERTY AND ITEMS COUNT TO ALL MATERIALS ADDED TO THE REPORT
            this.updateMaterials();
            // ADD IS SELECTED PROPERTY AND ITEMS COUNT TO ALL ACTIVITIES ADDED TO THE REPORT
            this.updateActivities();
            // ADD IS SELECTED PROPERTY AND ITEMS COUNT TO ALL MECHANIZATIONS ADDED TO THE REPORT
            this.updateMechanizations();
            // update the items count (hourlyRate) in the tools
            this.updateTools();
            // ADD IS SELECTED PROPERTY AND ITEMS COUNT TO ALL MECHANIZATIONS ADDED TO THE REPORT
            this.updateRentedMechanizations();
            if (this.report.isInvalid) {
              this.allowSave = false;
              this.$snotify.warning(
                "Грешните отчети не могат да бъдат редактирани!"
              );
            }

            if (this.report.planned) {
              if (this.$route.query.plan !== "true") {
                this.$router.push({ query: { plan: "true" } });
              }
              setTimeout(() => {
                this.isConvertPlannedToRealReportOpen = true;
              }, 1000);
            } else {
              if (this.$route.query.plan === "true") {
                this.$router.push({ query: {} });
              }
            }
          });
        })
        .catch((error) => console.log(error));
    },
    isValid() {
      if (!this.report.company._id.length) {
        this.$snotify.error("Не сте избрали отдел!");
        return false;
      }
      if (!this.report.project._id.length) {
        this.$snotify.error("Не сте избрали проект!");
        return false;
      }
      // if (!this.report.workers.length) {
      //   this.$snotify.error('Трябва да сте избрали поне един работник!');
      //   return false;
      // }
      if (
        !this.report.workers.length &&
        !this.report.materials.length &&
        !this.report.activities.length &&
        !this.report.mechanizations.length &&
        !this.report.rentedMechanizations.length
      ) {
        this.$snotify.error("Не може да запишете празен отчет!");
        return false;
      }
      for (let w of this.report.workers) {
        if (
          (!w.startHour || !w.endHour) &&
          !w.plannedStartHour &&
          !w.plannedEndHour
        ) {
          this.$snotify.error(
            "Всички работници трябва да имат добавени начален и краен час"
          );
          return false;
        }
      }
      for (let m of this.report.mechanizations) {
        if (m.items < 0) {
          this.$snotify.error(
            "Количеството собствена механизация не може да е отрицателно число"
          );
          return false;
        }
      }
      for (let m of this.report.rentedMechanizations) {
        if (m.items < 0) {
          this.$snotify.error(
            "Количеството наета механизация не може да е отрицателно число"
          );
          return false;
        }
      }
      for (let m of this.report.materials) {
        if (m.items < 0) {
          this.$snotify.error(
            "Количеството материал не може да е отрицателно число"
          );
          return false;
        }
      }
      for (let a of this.report.activities) {
        if (a.items < 0) {
          this.$snotify.error(
            "Количеството дейност не може да е отрицателно число"
          );
          return false;
        }
      }

      for (let x of ["workers", "mechanizations", "rentedMechanizations"]) {
        for (let y of this.report[x]) {
          if (y.tasks) {
            for (let t of y.tasks) {
              if (!t.startHour || !t.endHour) {
                this.$snotify.error(
                  "Всички задачи трябва да имат добавени начален и краен час"
                );
                return false;
              }
            }
          }
        }
      }

      return true;
    },
    removeTempIds() {
      if (this.report.materials.length) {
        this.report.materials.map((m) => {
          if (m.tempId) {
            delete m._id;
          }
        });
      }
      if (this.report.activities.length) {
        this.report.activities.map((a) => {
          if (a.tempId) {
            delete a._id;
          }
        });
      }
      if (this.report.mechanizations.length) {
        this.report.mechanizations.map((m) => {
          if (m.tempId) {
            delete m._id;
          }
        });
      }
      if (this.report.rentedMechanizations.length) {
        this.report.rentedMechanizations.map((m) => {
          if (m.tempId) {
            delete m._id;
          }
        });
      }
    },
    validateReport() {
      let url = `${process.env.VUE_APP_BASE_URI}/report/validate-report`;
      return this.$http.post(url, this.report);
    },
    // POST NEW REPORT
    postReport() {
      this.saving = true;
      if (this.isValid()) {
        this.validateReport()
          .then((a) => {
            if (a.data.errors) {
              this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
              this.saving = false;
            }
            if (a.data.exists.length) {
              for (let i = 0; i < a.data.exists.length; i++) {
                this.$snotify.error(
                  `${a.data.exists[i].workers.name} е вече добавен/а към друг отчет в диапазона ${a.data.exists[i].workers.startHour} - ${a.data.exists[i].workers.endHour}`
                );
              }
              this.saving = false;
            } else if (a.data.existingMechanizations.length) {
              a.data.existingMechanizations.filter(
                (mechanizationReport, index) => {
                  this.$snotify.error(
                    `${index + 1}. Строителна техника ${
                      mechanizationReport.mechanizations.name
                    } (част ${
                      mechanizationReport.mechanizations.part
                    }) е вече добавен/а към друг отчет за тази дата`
                  );
                }
              );

              this.saving = false;
            } else if (a.data.existingTools.length) {
              a.data.existingTools.filter((toolReport, index) => {
                this.$snotify.error(
                  `${index + 1}. Интрумент ${toolReport.tools.name} (част ${
                    toolReport.tools.part
                  }) е вече добавен/а към друг отчет за тази дата`
                );
              });

              this.saving = false;
            } else if (a.data.existingRentedMechanizations.length) {
              for (
                let i = 0;
                i < a.data.existingRentedMechanizations.length;
                i++
              ) {
                this.$snotify.error(
                  `Наета механизация ${a.data.existingRentedMechanizations[i].rentedMechanizations.name} (част ${a.data.existingRentedMechanizations[i].rentedMechanizations.part}) е вече добавен/а към друг отчет за тази дата`
                );
              }
              this.saving = false;
            } else {
              this.removeTempIds();
              this.report.createdBy._id = this.getUser._id;
              this.report.createdBy.name = this.getUser.name;
              if (this.report.part) {
                if (!this.report.part._id) {
                  delete this.report.part;
                }
              }

              if (this.checkIsvisible() && !this.report.planned)
                this.$set(this.report, "sendMail", true);

              let url = `${process.env.VUE_APP_BASE_URI}/report`;
              this.$http
                .post(url, this.report)
                .then((a) => {
                  if (a.data.errors) {
                    this.$snotify.error(
                      "Нещо се обърка! Моля опитайте отново."
                    );
                    this.saving = false;
                  } else {
                    this.$snotify.success(
                      "Вашият отчет беше създаден успешно!"
                    );
                    this.newLog(
                      "newReport",
                      `проект - ${this.report.project.projectName}`
                    );
                    this.isReportChanged = false;
                    this.saving = false;
                    this.cancelReport();
                  }
                })
                .catch((error) => {
                  if (error.response) {
                    this.$snotify.error(error.response.data);
                  } else {
                    this.$snotify.error(
                      "Нещо се обърка! Моля опитайте отново."
                    );
                    console.error(error.message);
                  }
                  this.saving = false;
                });
            }
          })
          .catch((err) => {
            if (err.response) {
              this.$snotify.warning(err.response.data);
            } else {
              console.log(err.response);
            }
          });
      } else {
        this.saving = false;
      }
    },
    // EDIT REPORT
    editReport() {
      this.saving = true;
      if (this.isValid()) {
        this.validateReport().then((a) => {
          if (a.data.errors) {
            this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
            this.saving = false;
          }
          if (a.data.exists.length) {
            for (let i = 0; i < a.data.exists.length; i++) {
              this.$snotify.error(
                `${a.data.exists[i].workers.name} е вече добавен/а към друг отчет в диапазона ${a.data.exists[i].workers.startHour} - ${a.data.exists[i].workers.endHour}`
              );
            }
            this.saving = false;
          } else if (a.data.existingMechanizations.length) {
            for (let i = 0; i < a.data.existingMechanizations.length; i++) {
              this.$snotify.error(
                `Собствена механизация ${a.data.existingMechanizations[i].mechanizations.name} е вече добавен/а към друг отчет за тази дата`
              );
            }
            this.saving = false;
          } else if (a.data.existingRentedMechanizations.length) {
            for (
              let i = 0;
              i < a.data.existingRentedMechanizations.length;
              i++
            ) {
              this.$snotify.error(
                `Наета механизация ${a.data.existingRentedMechanizations[i].rentedMechanizations.name} е вече добавен/а към друг отчет за тази дата`
              );
            }
            this.saving = false;
          } else {
            this.removeTempIds();
            let url = `${process.env.VUE_APP_BASE_URI}/report/${this.$route.params.id}`;

            if (this.checkIsvisible() && !this.report.planned)
              this.$set(this.report, "sendMail", true);

            this.$http
              .put(url, this.report)
              .then(() => {})
              .catch((error) => {
                console.log(error);
                this.$snotify.error("Нещо се обърка! Моля опитайте отново.");
                this.saving = false;
              })
              .then(() => {
                this.$snotify.success("Промените са записани успешно!");
                this.isReportChanged = false;
                this.newLog(
                  "editReport",
                  `проект - ${this.report.project.projectName}`
                );
                this.saving = false;
                this.cancelReport();
              });
          }
        });
      } else {
        this.saving = false;
      }
    },
    // Cancel report and go back 1 route behind
    cancelReport() {
      let path = "/reports/own";
      if (!this.report.planned) {
        path += "?tab=reports";
      }
      this.$router.push(path);
    },
    reportChanged() {
      if (!this.isReportChanged) {
        this.isReportChanged = true;
      }
    },
    save() {
      if (!this.saving) {
        if (this.$route.name === "newReport") {
          this.postReport();
        } else if (this.$route.name === "editReport") {
          this.editReport();
        }
      }
    },
    checkForUnsavedData(next) {
      this.isUnsavedChangesModalOpened = true;
      this.$once("closeUnsavedChangesModal", (answer) => {
        // confirm
        if (answer) {
          next(false);
          this.save();
        }
        // decline
        else {
          next();
        }
        this.isUnsavedChangesModalOpened = false;
        this.isReportChanged = false;
      });
    },
    setAccessCache() {
      Object.keys(this.tabsData.reports.tabValues).forEach((key) => {
        this.accessCache[key] = getAccess(key, "reports");
      });
    },
  },
  mounted() {
    this.setAccessCache();
    this.today = new Date();
    this.today.setHours(23, 59, 59, 999);

    this.getCompanies();
    this.getLatestUsedCompanies();
    if (this.$route.name === "newReport") {
      if (this.$route.query.plan) {
        this.report.planned = true;
        var tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        this.report.date = tomorrow;
      } else {
        this.report.date = new Date();
      }
    } else if (this.$route.name === "editReport") {
      this.getReport();
    }
    // Start listening for children's events
    this.$on("saveAddUsersModal", this.handleWorkers);
    this.$on("saveAddMaterialsModal", this.handleMaterials);
    this.$on("saveAddActivitiesModal", this.handleActivities);
    this.$on("saveAddMechanizationsModal", this.handleMechanizations);
    this.$on(
      "saveAddRentedMechanizationsModal",
      this.handleRentedMechanizations
    );
    this.$on("getMaterialsAgain", this.getMaterials);
    this.$on("getActivitiesAgain", this.getActivities);
    this.$on("getMechanizationsAgain", this.getMechanizations);
    this.$on("getRentedMechanizationsAgain", this.getRentedMechanizations);
    this.$on("clearNewestMaterial", () => {
      this.newestMaterial = "";
    });
    this.$on("clearNewestActivity", () => {
      this.newestActivity = "";
    });
    this.$on("clearNewestMechanization", () => {
      this.newestMechanization = "";
    });
    // Close listening for children's events
    this.$on("closeAddUsersModal", this.closeAddWorkersModal);
    this.$on("closeAddMaterialsModal", this.closeAddMaterialsModal);
    this.$on("closeAddActivitiesModal", this.closeAddActivitiesModal);
    this.$on("closeAddMechanizationsModal", this.closeAddMechanizationsModal);
    this.$on(
      "closeAddRentedMechanizationsModal",
      this.closeAddRentedMechanizationsModal
    );
  },
  beforeRouteLeave(to, from, next) {
    if (this.isReportChanged) {
      this.checkForUnsavedData(next);
    } else {
      next();
    }
  },
  destroyed() {
    // Stop listening
    this.$off("saveAddUsersModal");
    this.$off("saveAddMaterialsModal");
    this.$off("saveAddActivitiesModal");
    this.$off("saveAddMechanizationsModal");
    this.$off("saveAddRentedMechanizationsModal");
    this.$off("getMaterialsAgain");
    this.$off("getActivitiesAgain");
    this.$off("getMechanizationsAgain");
    this.$off("getRentedMechanizationsAgain");
    this.$off("clearNewestMaterial");
    this.$off("clearNewestActivity");
    this.$off("clearNewestMechanizations");
    this.$off("clearNewestRentedMechanizations");

    this.$off("closeAddUsersModal");
    this.$off("closeAddMaterialsModal");
    this.$off("closeAddActivitiesModal");
    this.$off("closeAddMechanizationsModal");
    this.$off("closeAddRentedMechanizationsModal");
  },
};
</script>

<style scoped>
.new-report {
  padding: 10px 20px;
  -webkit-transition: background-color 0.3s;
  -moz-transition: background-color 0.3s;
  -ms-transition: background-color 0.3s;
  -o-transition: background-color 0.3s;
  transition: background-color 0.3s;
}
.new-report--planned {
  background-color: #ece0c6;
  min-height: calc(100vh - 40px);
}
.new-report--flash {
  animation: flash 2s forwards;
}
@keyframes flash {
  0% {
    background-color: var(--color-main);
  }
  20% {
    background-color: #ece0c6;
  }
  40% {
    background-color: var(--color-main);
  }
  60% {
    background-color: #ece0c6;
  }
  80% {
    background-color: var(--color-main);
  }
  100% {
    background-color: transparent;
  }
}
.report-header {
  align-items: center;
  display: flex;
  height: 30px;
  justify-content: space-between;
  margin-bottom: 10px;
}
.heads {
  align-items: center;
  display: flex;
  justify-content: flex-start;
}
.title {
  margin-left: 0.5em;
}
.italic {
  font-style: italic;
}
.italic::placeholder {
  font-style: italic;
}
.italic::-moz-placeholder {
  font-style: italic;
}
.italic:-moz-placeholder {
  font-style: italic;
}
.italic:-ms-input-placeholder {
  font-style: italic;
}
.italic::-webkit-input-placeholder {
  font-style: italic;
}
/* .desktop { */
/* display: flex; */
/* } */
.mobile {
  display: none;
}
.icon--date {
  color: #212121;
}
.icon--company {
  color: #d67e00;
}
.icon--project {
  color: #a1260d;
}
.icon-notVisible {
  color: #a1260d;
  cursor: pointer;
  font-size: 18px;
  font-weight: normal;
  position: initial;
}
.icon--delete {
  margin-left: -18px;
}
.name-buttons-wrapper {
  align-items: center;
  background: #dce4e9 0% 0% no-repeat padding-box;
  border-radius: 2px;
  color: #005a9e;
  display: flex;
  /* height: 20px; */
  justify-content: space-between;
  padding: 3px 5px;
  margin-right: 150px;
  width: 390px;
}
.decision-wrapper {
  display: flex;
  gap: 5px;
  justify-content: center;
}
.tasks-buttons {
  align-items: center;
  display: flex;
  gap: 5px;
  justify-content: center;
}
.tasks-buttons .mck {
  color: #005a9e;
  cursor: pointer;
  font-size: 13px;
}
.tasks-buttons .toggle-tasks {
  font-size: 20px;
}
.add-remove {
  align-items: center;
  display: flex;
  gap: 3px;
}
.tasks {
  color: #000;
  display: flex;
  flex-direction: column;
  gap: 5px;
  padding: 5px 0 5px 80px;
  position: relative;
}
.tasks input {
  background: #e8e8e8 0% 0% no-repeat padding-box;
  border-radius: 4px;
  border: 0;
  height: 20px;
  padding: 5px 15px 5px 25px;
  position: relative;
  margin-right: 180px;
  width: 367px;
}
.tasks .tasks-hours-selection {
  display: flex;
  gap: 25px;
  position: relative;
}
.tasks .tasks-hours-selection .select-hour {
  position: relative;
  z-index: 1;
}
.tasks .tasks-hours-selection .select-hour::after {
  background: #e8e8e8;
  content: "";
  height: 1.5px;
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 0;
  width: 29px;
  z-index: -1;
}
.tasks .tasks-hours-selection::before {
  content: "";
  position: absolute;
  left: -15px;
  top: -30px;
  background: #e8e8e8;
  height: calc(230% - 9px);
  width: 1.5px;
  z-index: 1;
}
.tasks .tasks-hours-selection::after {
  content: "";
  position: absolute;
  left: 50%;
  top: -30px;
  background: #e8e8e8;
  width: 1.5px;
  height: calc(230% - 10px);
  z-index: 1;
}
.number {
  align-items: center;
  background: #176fbf 0% 0% no-repeat padding-box;
  border-radius: 50%;
  color: white;
  display: flex;
  font-size: 8px;
  justify-content: center;
  height: 11px;
  padding: 7px;
  width: 11px;
  z-index: 1;
}
.tasks .number {
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 12px;
}
.tasks .tasks-input-wrapper {
  align-items: center;
  display: flex;
  position: relative;
  width: fit-content;
}
.tasks-input-wrapper::after {
  background: #e8e8e8;
  content: "";
  height: 1.5px;
  position: absolute;
  transform: translate(-50%, -50%);
  top: 50%;
  left: 0;
  width: 29px;
}
.tasks::before {
  content: "";
  position: absolute;
  left: 65px;
  top: -5px;
  background: #e8e8e8;
  width: 1.5px;
  height: calc(100% - 10px);
  z-index: 1;
}
.icon-isVisible {
  color: #6bbf0b;
}
.no-user-select {
  align-items: center;
  display: flex;
  gap: 5px;
  margin: 3px 0 3px 0.5rem;
  user-select: none;
}
.new-wrapper--controlls .new-input-wrapper {
  margin-right: 5px;
  width: 200px;
}
.new-wrapper--controlls .new-input {
  margin: 0;
}
.new-wrapper--controlls .new-input-dropdown {
  top: calc(100% + 5px);
}
.new-wrapper--controlls .new-content-data-item-toggle {
  align-items: center;
  background-color: #deecf9;
  color: #005a9e;
  font-size: 11px;
  font-weight: 500;
  display: inline-flex;
  height: 35px;
  justify-content: space-between;
  padding: 0 5px;
  width: 130px;
}
.new-wrapper--controlls .new-content-data-item-toggle .mck,
.new-wrapper--controlls .new-content-data-item-toggle .mck2 {
  font-size: 16px;
  font-weight: 400;
}
.new-wrapper--controlls .new-content-data-item-toggle p {
  line-height: 0.9rem;
  text-align: right;
}
.new-wrapper--controlls
  .new-content-data-item:not(.new-content-data-item--transparent)
  .new-content-data-item-toggle:hover {
  background-color: #005a9e;
  color: #fff;
}
.new-content-data-item {
  margin-right: 5px;
}
.new-content-data-item:last-child {
  margin-right: 0;
}
.new-wrapper--controlls
  .new-content-data-item--transparent
  .new-content-data-item-toggle {
  cursor: default;
  opacity: 0.5;
}
.date {
  cursor: pointer;
}
.indicator-display {
  align-items: center;
  display: flex;
  height: 40px;
  justify-content: space-between;
  padding: 5px 15px 5px 40px;
}
.indicator-inactive {
  background-color: #c4c4c4;
}
.new-wrapper--controlls {
  justify-content: space-between;
}
.new-content-inputs {
  width: initial;
}
.new-wrapper--content {
  margin-top: 10px;
}
.help-img {
  width: 100%;
}
.new-wrapper-invalid {
  background-color: #fff8f8;
}
.invalid-report-wrap {
  align-items: center;
  /* background-color: #f4f4f4; */
  border-radius: 4px;
  display: flex;
  justify-content: space-between;
  padding: 10px;
}
.invalid-report-wrap .switch-wrapper {
  align-items: center;
  display: flex;
}
.invalid-report-wrap .switch {
  margin: 0;
}
.invalid-report-wrap .switch-label {
  align-items: center;
  display: flex;
}
.invalid-report-wrap .slider {
  background-color: #c4c4c4;
}
.invalid-report-wrap input:checked + .slider {
  background-color: #c50613;
}
.invalid-report-wrap .flag {
  height: 24px;
  margin: 0 8px;
}
.invalid-report-wrap > p {
  padding-right: 20px;
}
.title .flag {
  height: 24px;
  vertical-align: baseline;
  margin: 0 5px;
}
.title span {
  display: inline-flex;
  align-items: center;
}
.link {
  color: #0078d7 !important;
  display: inline-block;
  margin-left: 20px;
  text-decoration: underline;
}
.link:hover {
  opacity: 0.7;
}

.new-content-data-item-content {
  padding: 0;
}
.new-content-data-row {
  border-top: 0;
  margin-top: 0;
  padding-top: 0;
}
.new-content-data-row-active .new-content-data-item-toggle {
  display: table-header-group;
}
.new-content-data-item.expense {
  background-color: rgba(255, 205, 210, 0.2);
}
.new-content-data-item.expense .new-content-data-item-toggle {
  background-color: #ffcdd2;
}
.new-content-data-item.expense .new-content-data-item-toggle:hover {
  background-color: rgba(255, 205, 210, 0.8);
  color: #000;
}
.new-content-data-item.income {
  background-color: rgba(220, 237, 200, 0.2);
}
.new-content-data-item.income .new-content-data-item-toggle {
  background-color: #dcedc8;
}
.new-content-data-item.income .new-content-data-item-toggle:hover {
  background-color: rgba(220, 237, 200, 0.8);
  color: #000;
}
.new-content-data-item.inventory {
  background-color: rgba(151, 151, 151, 0.2);
}
.new-content-data-item.inventory .new-content-data-item-toggle {
  background-color: #979797;
  color: #fff;
  cursor: default;
  font-weight: 700;
}
.new-content-data-item.inventory .new-content-data-item-toggle:hover {
  background-color: #979797;
}
.new-content-data-item-toggle tr {
  display: table-row;
}
.new-content-data-item-content {
  overflow: auto;
  width: 100%;
}
.new-content-data-item-content table {
  border-collapse: collapse;
  width: 100%;
}
.new-content-data-item-content tbody {
  padding: 10px;
}
.new-content-data-item-content thead tr td {
  padding: 10px;
}
.new-content-data-item-content tbody tr td {
  color: #000;
  font-size: 11px;
}
.new-content-data-item-content tr td {
  padding: 1px 10px;
  min-width: 125px;
  vertical-align: middle;
}
.new-content-data-item-content .part-tr td {
  color: #000;
  font-size: 14px;
  font-weight: 700;
  padding-top: 10px;
}
.new-content-data-item-content .part-tr td:first-child {
  color: #005a9e;
}
.new-content-data-item-content .part-tr .part-name-span {
  text-transform: uppercase;
  position: relative;
}
.new-content-data-item-content .part-tr .part-name-span::before {
  content: "i";
  font-family: "mck";
  left: -20px;
  position: absolute;
  text-transform: lowercase;
  top: 50%;
  transform: translateY(-50%);
}
.part-name-wrapper {
  align-items: center;
  display: flex;
  gap: 5px;
  padding-bottom: 10px;
}
.new-content-data-item-content .part-tr td:first-child {
  text-align: left;
}
.new-content-data-item-content tr .padding-right {
  padding-right: 30px;
}
.new-content-data-item-content table tr td.no-min {
  min-width: initial;
  text-align: left;
}
.new-content-data-item-content tr td:first-child {
  width: 100%;
}
.new-content-data-item-content tr td:last-child {
  min-width: initial;
}
.new-content-data-item-content tr td:not(:first-child) {
  white-space: nowrap;
}
.new-content-data-item-content tr td:not(:first-child) {
  text-align: right;
}
.new-content-data-item-content thead tr td:first-child {
  border-top-left-radius: 4px;
  white-space: nowrap;
}
.new-content-data-item-content thead tr td:last-child {
  border-top-right-radius: 4px;
}
.new-content-data-item-content tbody tr:first-child td {
  padding-top: 10px;
}
.new-content-data-item-content tbody tr:last-child td {
  padding-bottom: 10px;
}
.new-content-data-item-content tbody tr td:first-child {
  padding-left: 30px;
}
.new-content-data-item-content tbody tr td:last-child:not(:first-child) {
  text-align: right;
}
.new-content-data-row-active .new-content-data-item-toggle-circle {
  position: relative;
  right: 0;
  top: 10px;
}
.new-content-data-item-toggle-circle .mck {
  margin: 0;
}
.new-content-data-item-content tbody .tr-totals td {
  color: #373737;
  font-weight: 700;
  font-size: 14px;
  padding-top: 10px;
  text-align: right;
}
.new-content-data-item-content tbody .tr-totals td:first-child {
  padding-right: 0;
  text-align: left;
}
.new-content-data-item-content tbody .tr-totals td:last-child {
  padding-left: 0;
}
.tr-totals__expense {
  color: #db0000;
}
.tr-totals__income {
  color: #2b7500;
}
.tr-totals__balance {
  color: #000;
}
.new-content-data-item-content
  tbody
  .tr-totals
  td:not(:last-child):not(:first-child) {
  padding-left: 0;
  padding-right: 0;
}
.new-content-data-item-content tbody .tr-totals td:last-child p {
  padding-left: 20px;
}
.new-content-data-item-content tbody .tr-totals td p {
  border-top: 1px solid #9c9c9c;
  padding-top: 10px;
}
.ma-cell-name .mck {
  bottom: 3px;
  left: 10px;
  transform: initial;
  top: initial;
}
.input-and-percent-wrapper {
  align-items: center;
  display: flex;
  justify-content: space-between;
}

.total-wrapper {
  align-items: center;
  background-color: #eeeeee;
  border-radius: 4px;
  display: flex;
  font-weight: 700;
  justify-content: space-between;
  margin-bottom: 5px;
  padding: 10px 10px 10px 30px;
  width: 100%;
}
.total-wrapper--red {
  background-color: #ffcdd2;
}
.total-wrapper--green {
  background-color: #dcedc8;
}
.worker-hours-toggle {
  cursor: pointer;
  font-size: 18px;
  line-height: 18px;
  margin-right: 5px;
  vertical-align: middle;
  -webkit-transition: color 0.3s;
  -moz-transition: color 0.3s;
  -ms-transition: color 0.3s;
  -o-transition: color 0.3s;
  transition: color 0.3s;
}
.worker-hours-toggle:hover {
  color: #0073e6;
}
.hidden {
  opacity: 0;
}
/* Responsive */
@media screen and (max-width: 1280px) {
  .indicator-display {
    padding-right: 2px;
  }
  .indicator-display .indicators {
    display: inline-flex;
  }
  .indicator-display .worktime-indicator {
    height: 34px;
    margin: 0 2px;
    width: 14px;
  }
  .indicator-display .worktime-indicator span {
    transform: rotate(-90deg);
    font-size: 9px;
    white-space: nowrap;
    font-weight: 700;
  }
}
@media screen and (max-width: 1000px) {
  .mobile {
    display: flex;
    width: 100%;
    flex-direction: row;
  }
  .new-report {
    padding: 10px 15px;
  }
  .new-content-inputs.desktop,
  .desktop {
    display: none;
  }
  .new-content {
    width: 100%;
  }
  .new-content-inputs.mobile {
    display: flex;
    flex-direction: column;
  }
  .new-input-wrapper {
    width: 100%;
  }
  /* .new-input.mobile.drop {
    padding: 15px;
  } */
  .new-content-inputs {
    flex-direction: column;
  }
  .date-irv-wrapper {
    display: flex;
    width: 100%;
  }
  .datepicker-dropdown-active {
    width: 210%;
  }
  .start-end-wrapper {
    display: flex;
    width: 100%;
  }
  .report-header {
    justify-content: flex-start;
  }
  .new-content-data-item-toggle.mobile {
    text-align: center;
    /* flex-direction: column; */
    height: auto;
    padding-bottom: 0.6em;
  }
  .new-content-data-row-toggles {
    flex-wrap: wrap;
  }
  .new-content-data-item-small {
    width: calc(50% - 10px);
    margin: 0;
  }
  .new-content-data-item-small:nth-child(2n) {
    margin-left: 20px;
  }
  .new-content-data-item-small:nth-child(1n + 3) {
    margin-top: 20px;
  }
  .new-content-data-item-small .new-content-data-item-toggle.mobile {
    flex-direction: column;
  }
  .new-content-data-item-toggle.mobile p {
    margin-top: 0.6em;
    margin-bottom: 0.6em;
    margin-right: 0px;
  }
  .new-content-data-item-content {
    overflow: auto;
  }
  .new-content-data-item-content .ma-cell,
  .new-content-data-item-content .users-cell,
  .new-content-data-item-togle .ma-cell {
    padding: 0px 10px 0 0;
  }
  .new-content-data-item-content .ma-cell-additional {
    padding-left: 15px;
  }
  .new-content-data-item-content .ma-cell-nowrap {
    white-space: nowrap;
  }
  .new-content-data-item-content .users-cell p {
    display: flex;
    -webkit-box-pack: end;
    -ms-flex-pack: end;
    justify-content: flex-end;
    margin-right: 0px;
  }
  .btns.mobile {
    display: flex;
    justify-content: center;
    margin-top: 1.5em;
    margin-bottom: 1.5em;
  }
  .date,
  .indicator-display {
    height: 51px;
  }
  .label {
    color: #373737;
    font-size: 11px;
    font-weight: 700;
  }
}
@media screen and (max-width: 600px) {
  .invalid-report-wrap {
    flex-direction: column;
  }
  .invalid-report-wrap > p {
    padding: 0 0 15px;
    text-align: center;
  }
}
</style>
